// @ts-ignore
import { useHistory, useLocation } from "react-router";
import {
  CloseButton,
  FormTitle,
  HorizontalContainer,
  InfoArea,
  ScreenRoot,
  SmallTitleText,
  StyledPaper,
  StyledTable,
} from "../styles";
import {
  ActionButton,
  BackButton,
  BackButtonContainer,
  ValueInput,
} from "./styles";
import React, { useEffect, useState } from "react";
import { FunctionalButton } from "../../../../components/functionalButton";
import Select from "../../../../components/selectField";
import { Dialog } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import PledgxLogo from "assets/common/pledgxLogo";
import Input from "../../../../components/inputField"; // import { dummyBalanceSheetSplit } from "../parser/dummy";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../components/filesListTable/styles";
import { saveTransferData } from "../../../../api/external_data";
import { AlertPopup } from "../../../../components/alertPopup/alertPopup";
import Success from "../../../../assets/dashboardIcons/Success";
import PylonIcon from "../../../../assets/common/pylonIcon.png";
import { ReactComponent as DeleteIcon } from "../../../../assets/common/deleteIcon.svg";

const friendlyLabelMappings = {
  "company-name": "Company Name",
  as_of_date: "As Of Date",
  project_status: "Project Status",
  "reporting-dates": "Reporting Dates",
  "reporting-year": "Reporting Year",
  "gross-contract-income": "Contract Revenue",
  "management-fee-income": "Management Fee Income",
  "other-operating-income": "Other Operating Income",
  "intercompany-revenue": "Intercompany Revenue",
  "total-operating-revenue": "Total Operating Revenue",
  "wage-expense": "Wage Expense",
  "subcontract-expense": "Subcontract Expense",
  "material-expense": "Material Expense",
  "equipment-expense": "Equipment Expense",
  "other-direct-expenses": "Other Direct Expenses",
  "exploration-and-evaluation-expense": "Exploration Expense",
  "intercompany-direct-expense": "Intercompany Direct Expense",
  "total-direct-expense": "Total Direct Expense",
  "gross-profit": "Gross Profit",
  "admin-expense": "Admin Expense",
  "other-non-operating-expense": "Other Operating Expense",
  "salary-and-bonus": "Salary And Bonus",
  depreciation: "Depreciation",
  "intercompany-overhead-expense": "Intercompany Overhead Expense",
  "total-overhead-expense": "Total Overhead Expense",
  "operating-profit": "Operating Profit",
  "other-income": "Other Income",
  "discretionary-bonus": "Discretionary Bonuses",
  "interest-expense": "Interest Expense",
  "income-tax-current": "Income Tax Current",
  "income-tax-deferred": "Income Tax Deferred",
  "net-income-after-tax": "Net Income After Tax",
  "depreciation-cf": "Depreciation",
  "bad-debt-expense": "Bad Debt Expense",
  other_non_cash: "Other Non Cash Items",
  "income-tax-deferred-cf": "Deferred Income Tax",
  "change-in-assets": "Change In Assets",
  "change-in-liabilities": "Change In Liabilities",
  "net-cash-operating": "Net Cash Operating",
  "net-cash-investing": "Net Cash Investing",
  "loan-proceeds": "Loan and Debt Proceeds",
  "loan-repayment": "Loan and Debt Repayment",
  dividends: "Dividends",
  other_financing: "Other Financing Items",
  "net-cash-financing": "Net Cash Financing",
  "net-cash-flow": "Net Cash Flow",
  cash: "Cash",
  "marketable-securities": "Marketable Securities",
  "accounts-receivable-progress": "Accounts Receivable",
  "accounts-receivable-retention": "Retention Receivable",
  "deferred-assets": "Contract Assets",
  inventory: "Inventory",
  "prepaid-expenses-current": "Current Prepaid Expenses",
  "other-current-assets": "Other Current Assets",
  "total-current-assets": "Total Current Assets",
  "prepaid-expenses-non-current": "NonCurrent Prepaid Expenses",
  "accounts-receivable-over-90days": "Accounts Receivable over 90days",
  "plant-and-equipment": "Plant and Equipment",
  "machinery-and-vehicles": "Machinery and Vehicles",
  "furniture-and-fixture": "Furniture and Fixture",
  "real-estate": "Real Estate",
  "other-fixed-assets": "Other Fixed Assets",
  "accumulated-depreciation": "Accumulated Depreciation",
  "other-non-current-assets": "Other NonCurrent Assets",
  "assets-on-lease": "Assets on Lease",
  "cash-restricted": "Restricted Cash",
  "shareholder-loans": "Loans to Shareholders",
  "intangible-assets": "Intangible Assets",
  "assets-written-off": "Assets Written Off",
  "total-assets": "Total Assets",
  "loan-payable": "Loans Payable",
  "bills-payable": "Bills Payable",
  "accounts-payable-progress": "Accounts Payable",
  "accounts-payable-retention": "Retention Payable",
  "other-payables": "Other Current Payables",
  "deferred-revenue": "Contract Liabilities",
  "current-portion-long-term-debt": "Current Portion LTD",
  "current-lease-liability": "Current Lease Liability",
  "employee-loans": "Employee Loans",
  "current-taxes": "Current Taxes",
  "deferred-taxes": "Current Portion Deferred Taxes",
  "loans-from-shareholders": "Loans From Shareholders",
  "accrued-expenses": "Accrued Expenses",
  "total-current-liabilities": "Total Current Liabilities",
  "long-term-loan-payable": "Long Term Loans",
  "long-term-lease-liability": "Long Term Lease Liability",
  "long-term-debt-other": "Long Term Other Debts",
  "long-term-deferred-tax": "Long Term Deferred Taxes",
  "other-liabilities": "Other NonCurrent Liabilities",
  "minority-interest": "Minority Interest",
  "total-liabilities": "Total Liabilities",
  "subordinated-debt": "Subordinated Debt",
  "share-capital": "Share Capital",
  "retained-earnings": "Retained Earnings",
  other_equity: "Other Equity",
  "net-worth": "Net Worth",
  "total-liability-net-worth": "Total Liabilities and Net Worth",
  currency: "Currency",
  "other-equity": "Other Equity",
  "net-income": "Net Income",
  "other-non-cash": "Other Non Cash",
  "other-financing": "Other Financing",
};

const financialDocumentPropertyOrdering = {
  balanceSheet: [
    "company-name",
    "reporting-dates",
    "reporting-year",
    "cash",
    "marketable-securities",
    "accounts-receivable-progress",
    "accounts-receivable-retention",
    "deferred-assets",
    "inventory",
    "prepaid-expenses-current",
    "other-current-assets",
    "total-current-assets",
    "prepaid-expenses-non-current",
    "accounts-receivable-over-90days",
    "plant-and-equipment",
    "machinery-and-vehicles",
    "furniture-and-fixture",
    "real-estate",
    "other-fixed-assets",
    "accumulated-depreciation",
    "other-non-current-assets",
    "assets-on-lease",
    "cash-restricted",
    "shareholder-loans",
    "intangible-assets",
    "assets-written-off",
    "total-assets",
    "loan-payable",
    "bills-payable",
    "accounts-payable-progress",
    "accounts-payable-retention",
    "other-payables",
    "deferred-revenue",
    "current-portion-long-term-debt",
    "current-lease-liability",
    "employee-loans",
    "current-taxes",
    "deferred-taxes",
    "loans-from-shareholders",
    "accrued-expenses",
    "total-current-liabilities",
    "long-term-loan-payable",
    "long-term-lease-liability",
    "long-term-debt-other",
    "long-term-deferred-tax",
    "other-liabilities",
    "minority-interest",
    "total-liabilities",
    "subordinated-debt",
    "share-capital",
    "retained-earnings",
    "other-equity",
    "net-worth",
    "total-liability-net-worth",
  ],
  profitAndLoss: [
    "company-name",
    "reporting-dates",
    "reporting-year",
    "gross-contract-income",
    "management-fee-income",
    "other-operating-income",
    "intercompany-revenue",
    "total-operating-revenue",
    "wage-expense",
    "subcontract-expense",
    "material-expense",
    "equipment-expense",
    "other-direct-expenses",
    "exploration-and-evaluation-expense",
    "intercompany-direct-expense",
    "total-direct-expense",
    "gross-profit",
    "admin-expense",
    "other-non-operating-expense",
    "salary-and-bonus",
    "depreciation",
    "intercompany-overhead-expense",
    "total-overhead-expense",
    "operating-profit",
    "other-income",
    "discretionary-bonus",
    "interest-expense",
    "income-tax-current",
    "income-tax-deferred",
    "net-income-after-tax",
  ],
  cashflow: [
    "company-name",
    "reporting-dates",
    "reporting-year",
    "net-income",
    "depreciation-cf",
    "bad-debt-expense",
    "other-non-cash",
    "income-tax-deferred-cf",
    "change-in-assets",
    "change-in-liabilities",
    "net-cash-operating",
    "net-cash-investing",
    "loan-proceeds",
    "loan-repayment",
    "dividends",
    "other-financing",
    "net-cash-financing",
    "net-cash-flow",
  ],
};

const wipOrWorkCompletedProjectProperties = [
  "billings_to_date",
  "contract_number",
  "cost_incurred_to_date",
  "current_year_contract_costs",
  "current_year_earned_revenue",
  "estimated_cost_of_revenue",
  "estimated-gross-profit",
  "project_name",
  "project_value_or_estimated_revenue",
];

const modelMappings = {
  profitAndLoss: "Profit and Loss",
  cashflow: "Cash Flow",
  balanceSheet: "Balance Sheet",
  workInProgress: "Work In Progress",
  workCompleted: "Work Completed",
};

export default function LabelEditor() {
  const location = useLocation();
  const history = useHistory();

  const [showEditFieldPopup, setShowEditFieldPopup] = useState(false);

  const [editingFieldData, setEditingFieldData] = useState(null);

  const [showDeleteConfirmationPopup, setShowDeleteConfirmationPopup] =
    useState(false);

  const [propertyToDelete, setPropertyToDelete] = useState({
    property: null,
    type: null,
    entityIndex: null,
  });

  const [pdfSrc, setPdfSrc] = useState();

  const {
    splitFile,
    pdfBlob,
    selectedAccount,
    selectedSubsidiary,
    clientDocumentsId,
    splitFiles,
    index,
    labellerResponse,
    documentFiles,
    documentId,
    file,
  } = location.state || {};

  const [isSaving, setIsSaving] = useState(false);

  const [newData, setNewData] = useState(splitFile);
  //console.log("split file in document viewer ", newData);

  const [selectedAccountData, setSelectedAccountData] =
    useState(selectedAccount);
  const [selectedSubsidiaryData, setSelectedSubsidiaryData] =
    useState(selectedSubsidiary);
  const [clientDocumentsIdData, setClientDocumentsIdData] =
    useState(clientDocumentsId);
  const [splitFilesData, setSplitFilesData] = useState(splitFiles);
  const [showSaveFieldChangesFailedPopup, setShowSaveFieldChangesFailedPopup] =
    useState(false);
  const [
    showSaveFieldChangesSuccessPopup,
    setShowSaveFieldChangesSuccessPopup,
  ] = useState(false);

  useEffect(() => {
    const matchedSplit = splitFilesData.find(
      (data) => data.splitFiles[0].id === newData.id,
    );

    console.log(
      "Matched split entities: ",
      matchedSplit.splitFiles[0].labellerOutput.entities,
    );

    let currentId = getNewestId(matchedSplit.splitFiles[0]);

    if (isWipOrWorkCompletedDocument(newData.labellerModel)) {
      const asOfDate = matchedSplit.splitFiles[0].labellerOutput.entities.find(
        (entity) => entity.type === "as_of_date",
      );
      if (!asOfDate) {
        setSplitFilesData((oldData) => {
          return oldData.map((data) => {
            if (data.splitFiles[0].id === matchedSplit.splitFiles[0].id) {
              return {
                ...data,
                splitFiles: [
                  {
                    ...data.splitFiles[0],
                    labellerOutput: {
                      ...data.splitFiles[0].labellerOutput,
                      entities: [
                        ...data.splitFiles[0].labellerOutput.entities,
                        {
                          id: (++currentId).toString(),
                          type: "as_of_date",
                          mentionText: "No Value",
                        },
                      ],
                    },
                  },
                ],
              };
            }
            return data;
          });
        });
      }

      const projectStatus =
        matchedSplit.splitFiles[0].labellerOutput.entities.find(
          (entity) => entity.type === "project_status",
        );
      if (!projectStatus) {
        setSplitFilesData((oldData) => {
          return oldData.map((data) => {
            if (data.splitFiles[0].id === matchedSplit.splitFiles[0].id) {
              return {
                ...data,
                splitFiles: [
                  {
                    ...data.splitFiles[0],
                    labellerOutput: {
                      ...data.splitFiles[0].labellerOutput,
                      entities: [
                        ...data.splitFiles[0].labellerOutput.entities,
                        {
                          id: (++currentId).toString(),
                          type: "project_status",
                          mentionText: "No Value",
                        },
                      ],
                    },
                  },
                ],
              };
            }
            return data;
          });
        });
      }
    }

    const companyName = matchedSplit.splitFiles[0].labellerOutput.entities.find(
      (entity) => entity.type === "company-name",
    );

    if (!companyName) {
      setSplitFilesData((oldData) => {
        return oldData.map((data) => {
          if (data.splitFiles[0].id === matchedSplit.splitFiles[0].id) {
            return {
              ...data,
              splitFiles: [
                {
                  ...data.splitFiles[0],
                  labellerOutput: {
                    ...data.splitFiles[0].labellerOutput,
                    entities: [
                      ...data.splitFiles[0].labellerOutput.entities,
                      {
                        id: (++currentId).toString(),
                        type: "company-name",
                        mentionText: "No Value",
                      },
                    ],
                  },
                },
              ],
            };
          }
          return data;
        });
      });
    }

    if (isFinancialDocument(newData.labellerModel)) {
      const reportingDates =
        matchedSplit.splitFiles[0].labellerOutput.entities.find(
          (entity) => entity.type === "reporting-dates",
        );
      if (!reportingDates) {
        setSplitFilesData((oldData) => {
          return oldData.map((data) => {
            if (data.splitFiles[0].id === matchedSplit.splitFiles[0].id) {
              return {
                ...data,
                splitFiles: [
                  {
                    ...data.splitFiles[0],
                    labellerOutput: {
                      ...data.splitFiles[0].labellerOutput,
                      entities: [
                        ...data.splitFiles[0].labellerOutput.entities,
                        {
                          id: (++currentId).toString(),
                          type: "reporting-dates",
                          mentionText: "No Value",
                        },
                      ],
                    },
                  },
                ],
              };
            }
            return data;
          });
        });
      }
    }
  }, [splitFilesData]);

  useEffect(() => {
    let unnamedProjectCount = 0,
      unnamedYearCount = 0;

    const matchedSplit = splitFilesData.find(
      (data) => data.splitFiles[0].id === newData.id,
    );

    if (!matchedSplit) {
      console.log("Error: a matching split was not found");
    }

    let currentId = getNewestId(matchedSplit.splitFiles[0]);

    setSplitFilesData((oldData) => {
      const updatedData = oldData.map((data) => {
        if (data.splitFiles[0].id === newData.id) {
          const updatedEntities =
            data.splitFiles[0].labellerOutput.entities.map((entity) => {
              if (entity.type === "project") {
                const projectNameIndex = entity.properties.findIndex(
                  (property) => property.type == "project_name",
                );

                if (projectNameIndex == -1) {
                  return {
                    ...entity,
                    properties: [
                      ...entity.properties,
                      {
                        type: "project_name",
                        id: (++currentId).toString(),
                        confidence: 0,
                        mentionText: `Unnamed Project ${++unnamedProjectCount}`,
                      },
                    ],
                  };
                } else {
                  return entity;
                }
              }

              if (entity.type === "year") {
                const reportingYearIndex = entity.properties.findIndex(
                  (property) => property.type == "reporting-year",
                );

                if (reportingYearIndex == -1) {
                  return {
                    ...entity,
                    properties: [
                      ...entity.properties,
                      {
                        type: "reporting-year",
                        id: (++currentId).toString(),
                        confidence: 0,
                        mentionText: `Unnamed Year ${++unnamedYearCount}`,
                      },
                    ],
                  };
                } else {
                  return entity;
                }
              }

              return entity;
            });

          return {
            ...data,
            splitFiles: [
              {
                ...data.splitFiles[0],
                labellerOutput: {
                  ...data.splitFiles[0].labellerOutput,
                  entities: updatedEntities,
                },
              },
            ],
          };
        }
        return data;
      });
      return updatedData;
    });
  }, []);

  const updateSplitWithNewOrEditedFieldData = () => {
    const updatedSplitFiles = splitFilesData.map((file) =>
      file.splitFiles[0].id === newData.id ? { ...file, isEdited: true } : file,
    );
    setSplitFilesData(updatedSplitFiles);

    let currentId = newestId;
    if (editingFieldData.mode === "new") {
      console.log("saving changes for new field", editingFieldData);
      if (isFinancialDocument(newData.labellerModel)) {
        const year = editingFieldData.entity.year;

        if (year === "New Reporting Year") {
          newData.labellerOutput.entities.push({
            id: (++currentId).toString(),
            type: "year",
            properties: [
              {
                id: (++currentId).toString(),
                type: "reporting-year",
                mentionText: editingFieldData.entity.mentionText,
                confidence: 1,
              },
            ],
          });

          setNewData(newData);
          handleClose();
          setIsSaving(true);
          return;
        }

        const yearEntityIndex = newData.labellerOutput.entities.findIndex(
          (entity) => {
            if (entity.type !== "year") return false;

            const reportingYearProperty = entity.properties.find(
              (prop) => prop.type === "reporting-year",
            );

            return (
              reportingYearProperty &&
              reportingYearProperty.mentionText === year
            );
          },
        );

        console.log("yearEntity ", yearEntityIndex);

        newData.labellerOutput.entities[yearEntityIndex].properties.push(
          editingFieldData.entity,
        );

        console.log(
          "after push: ",
          newData.labellerOutput.entities[yearEntityIndex].properties.filter(
            (property) => property.id === undefined,
          ),
        );
        //
        setNewData(newData);
        setIsSaving(true);
        handleClose();
      } else if (isWipOrWorkCompletedDocument(newData.labellerModel)) {
        const projectName = editingFieldData.entity.project;

        if (projectName === "New Project") {
          newData.labellerOutput.entities.push({
            id: (++currentId).toString(),
            type: "project",
            properties: [
              {
                id: (++currentId).toString(),
                type: "project_name",
                mentionText: editingFieldData.entity.mentionText,
                confidence: 1,
              },
            ],
          });

          setNewData(newData);
          handleClose();
          setIsSaving(true);
          return;
        }
        // handle edge case where project_name is the new field being added (we can't use it to search)
        if (editingFieldData.entity.type === "project_name") {
          const projectIndex = newData.labellerOutput.entities.findIndex(
            (entity) => entity.id === editingFieldData.projectId,
          );
          console.log("project index: ", projectIndex);
        }
        setIsSaving(true);

        const ProjectIndex = newData.labellerOutput.entities.findIndex(
          (entity) =>
            entity.properties.some(
              (prop) =>
                prop.type === "project_name" &&
                prop.mentionText.toLowerCase() === projectName.toLowerCase(),
            ),
        );
        //console.log("ProjectIndex ", ProjectIndex);
        if (ProjectIndex === -1) {
          console.log(
            `couldn't find a match for a project with the project_name of "${projectName}"`,
          );
          return;
        }

        newData.labellerOutput.entities[ProjectIndex].properties.push(
          editingFieldData.entity,
        );

        setNewData(newData);
        handleClose();
        setIsSaving(true);
      } else {
        console.log("Unknown document type");
      }
      setNewestId((prevNewestId) => prevNewestId + 1);
    } else if (editingFieldData.mode === "edit") {
      console.log("editing field: ", editingFieldData);
      console.log("all entites", newData.labellerOutput.entities);
      // Updating non-project or year nested labels
      const id =
        editingFieldData.projectId ||
        editingFieldData.yearId ||
        editingFieldData.entity.id;

      // if the user is editing a property not under a year or a project
      if (!editingFieldData.propertyCopy) {
        const parentEntityIndex = newData.labellerOutput.entities.findIndex(
          (entity) => entity.id === id,
        );
        if (parentEntityIndex !== -1) {
          console.log("non-year or project edit");
          newData.labellerOutput.entities[parentEntityIndex].mentionText =
            editingFieldData.entity.mentionText;

          setNewData(newData);
          handleClose();
          setIsSaving(true);
        } else {
          console.log("Couldn't find parent entity with associated index");
        }
      }

      // if the user is editing a property under a year or a project
      if (editingFieldData.propertyCopy) {
        console.log("year or project property edit");
        let parentEntityIndex = -1;
        let propertyIndex = -1;

        newData.labellerOutput.entities.forEach((entity, entityIndex) => {
          if (
            (isFinancialDocument(newData.labellerModel) &&
              entity.type === "year") ||
            (!isFinancialDocument(newData.labellerModel) &&
              entity.type === "project")
          ) {
            const foundPropertyIndex = entity.properties.findIndex(
              (property) => property.id == editingFieldData.propertyCopy.id,
            );

            if (foundPropertyIndex !== -1) {
              parentEntityIndex = entityIndex;
              propertyIndex = foundPropertyIndex;
            }
          }
        });

        if (parentEntityIndex !== -1 && propertyIndex !== -1) {
          console.log(
            "properties: ",
            newData.labellerOutput.entities[parentEntityIndex].properties,
            " property index: ",
            propertyIndex,
          );

          newData.labellerOutput.entities[parentEntityIndex].properties[
            propertyIndex
          ].mentionText = editingFieldData.propertyCopy.mentionText;

          newData.labellerOutput.entities[parentEntityIndex].properties[
            propertyIndex
          ].type = editingFieldData.propertyCopy.type;
          //console.log("newData.labellerOutput.entities[parentEntityIndex]", newData);

          setNewData(newData);
          handleClose();
          setIsSaving(true);
        } else {
          console.log(
            "Couldn't find the property entity with associated index",
          );
        }
      }
    }
  };

  // handle missing project_name and reporting-years with default value
  useEffect(() => {
    console.log("pdf blob ", pdfBlob.fileName);
    const pdfUrl = URL.createObjectURL(
      new Blob([pdfBlob], { type: "application/pdf" }),
    );

    setPdfSrc(pdfUrl);

    return () => {
      URL.revokeObjectURL(pdfUrl);
    };
  }, [pdfBlob]);

  const handleClose = () => {
    setShowEditFieldPopup(false);
  };

  useEffect(() => {
    //console.log("New data updated:",newData );
    if (isSaving) {
      handleClose();
      setIsSaving(false);
    }
  }, [newData]);

  const handleBackClick = () => {
    //console.log("data sent back to parser screen ");
    //   updatedFinancialData: newData,
    //   selectedAccount:selectedAccountData,
    //   clientDocumentsId:clientDocumentsIdData,
    //   splitFilesCount:splitFileCountData,
    // });
    //console.log("documents ", documents);
    //console.log("index ", index);
    //console.log("newData ", newData);
    // const editedSplitDocuments = updateSplitFile(
    //   labellerResponse,
    //   index,
    //   newData,
    // );
    //console.log("editedDocuments ", editedSplitDocuments);
    //console.log("isSaving ", isSaving);

    history.push({
      pathname: "/underwriter/idpdocuments/parser",
      search: "?ntld=true",
      state: {
        updatedFinancialData: newData,
        selectedAccount: selectedAccountData,
        selectedSubsidiary: selectedSubsidiaryData,
        clientDocumentsId: clientDocumentsIdData,
        splitFiles: splitFilesData,
        index: index,
        editedDocumentFiles: documentFiles,
        _labellerResponse: labellerResponse,
      },
    });
  };

  const handleSaveChanges = async () => {
    console.log("file ", file);
    const { bucketName, filePath, fileName, id } = file;

    const matchedSplit = splitFilesData.find(
      (data) => data.splitFiles[0].id === newData.id,
    );

    console.log("newData ", newData);

    const updatedData = {
      id: documentId,
      files: {
        bucketName,
        filePath,
        fileName,
        id,
        splitFiles: matchedSplit.splitFiles[0],
      },
    };

    console.log("update data ", updatedData);

    const data = {
      update_transfer_data: updatedData,
      split_file_id: newData.id,
      document_ai_process_data_id: documentId,
      client_documents_id: clientDocumentsId,
      labeller_model: newData.labellerModel,
      account_id: selectedAccount.AccountId || selectedSubsidiary.AccountId,
    };

    try {
      await saveTransferData(
        data,
        (response) => {
          console.log("saved ", response);
          setShowSaveFieldChangesSuccessPopup(true);
        },
        (error) => {
          console.log(`there was en error saving the data: ${error}`);
          setShowSaveFieldChangesFailedPopup(true);
        },
      );
    } catch (e) {
      console.log("error with saveTransferData");
    }
  };

  const isFinancialDocument = (labellerModel) => {
    return (
      labellerModel === "balanceSheet" ||
      labellerModel === "cashflow" ||
      labellerModel === "profitAndLoss"
    );
  };

  const isWipOrWorkCompletedDocument = (labellerModel) => {
    return (
      labellerModel === "workCompleted" || labellerModel === "workInProgress"
    );
  };

  console.log("here ", newData);

  const getNewestId = (data) => {
    let ids = [];
    data.labellerOutput.entities
      .filter(
        (entity) =>
          entity.type ===
          (isFinancialDocument(data.labellerModel) ? "year" : "project"),
      )
      .forEach(({ properties }) => {
        properties.forEach((property) => {
          ids.push(parseInt(property.id));
        });
      });

    return Math.max(...ids);
  };

  const [newestId, setNewestId] = useState(getNewestId(newData));

  const getUniqueReportingYears = (entities) => {
    let uniqueReportingYears = new Set();

    entities
      .filter((entity) => entity.type === "year")
      .forEach(({ properties }) => {
        properties.forEach(({ type, mentionText }) => {
          if (type === "reporting-year") uniqueReportingYears.add(mentionText);
        });
      });

    return [...uniqueReportingYears];
  };

  const [entries, setEntries] = useState(() => {
    const matchedSplit = splitFilesData.find(
      (data) => data.splitFiles[0].id === newData.id,
    );

    if (isFinancialDocument(newData.labellerModel)) {
      const entryData = financialDocumentPropertyOrdering[
        newData.labellerModel
      ].map((prop) => {
        let matchedProperties = [];

        matchedSplit.splitFiles[0].labellerOutput.entities
          .filter((entity) => entity.type === "year")
          .forEach((entity) => {
            const year = entity.properties.find(
              (p) => p.type === "reporting-year",
            ).mentionText;

            if (!year) {
              return {
                label: prop,
                propertyData: matchedProperties,
                rowData: [],
              };
            }

            const matchedProps = entity.properties.filter(
              (p) => p.type === prop,
            );

            if (matchedProps.length > 0) {
              matchedProps.forEach((p) => {
                matchedProperties.push({
                  year,
                  propertyId: p.id,
                  entityId: entity.id,
                });
              });
            }
          });

        matchedProperties.sort((a, b) => a.id - b.id);

        return {
          label: prop,
          propertyData: matchedProperties || [],
          rowData: [],
        };
      });

      entryData.forEach((entry) => {
        let rowData = [];
        let rowCount = 0;

        getUniqueReportingYears(newData.labellerOutput.entities).forEach(
          (year) => {
            const matches = entry.propertyData.filter((p) => p.year === year);

            if (matches.length > rowCount) {
              rowCount = matches.length;
            }
          },
        );

        [...Array(rowCount).keys()].forEach(() => {
          rowData.push([]);
        });

        getUniqueReportingYears(newData.labellerOutput.entities).forEach(
          (year) => {
            const matches = entry.propertyData.filter((p) => p.year === year);
            matches.sort((a, b) => a.propertyId - b.propertyId);

            rowData.forEach((row, i) => {
              rowData[i].push(matches[i]);
            });
          },
        );

        entry.rowData = rowData;
      });

      console.log("entries ", entryData);
      return entryData;
    }

    if (isWipOrWorkCompletedDocument(newData.labellerModel)) {
      const newEntries = newData.labellerOutput.entities
        .map((entity) => {
          if (entity.type === "project") {
            const contract_number =
              entity.properties.find(
                (property) => property.type === "contract_number",
              )?.mentionText || "0";
            const project_name =
              entity.properties.find(
                (property) => property.type === "project_name",
              )?.mentionText || "0";
            const estimated_revenue =
              entity.properties.find(
                (property) => property.type === "estimated_revenue",
              )?.mentionText || "0";
            const estimated_cost_of_revenue =
              entity.properties.find(
                (property) => property.type === "estimated_cost_of_revenue",
              )?.mentionText || "0";
            const estimated_gross_profit =
              entity.properties.find(
                (property) => property.type === "estimated-gross-profit",
              )?.mentionText || "0";
            const cost_incurred_to_date =
              entity.properties.find(
                (property) => property.type === "cost_incurred_to_date",
              )?.mentionText || "0";
            const billings_to_date =
              entity.properties.find(
                (property) => property.type === "billings_to_date",
              )?.mentionText || "0";
            const current_year_earned_revenue =
              entity.properties.find(
                (property) => property.type === "current_year_earned_revenue",
              )?.mentionText || "0";
            const current_year_contract_costs =
              entity.properties.find(
                (property) => property.type === "current_year_contract_costs",
              )?.mentionText || "0";

            return {
              entityId: entity.id,
              contract_number,
              project_name,
              estimated_revenue,
              estimated_cost_of_revenue,
              estimated_gross_profit,
              cost_incurred_to_date,
              billings_to_date,
              current_year_earned_revenue,
              current_year_contract_costs,
            };
          }
        })
        .filter((entry) => entry !== undefined);

      console.log("new entries", newEntries);

      return newEntries;
    }

    addMissingLabels();
  });

  // company-name
  // as_of_date
  // project_status
  // project_name
  // contract-number
  // project_value_or_estimated_revenue
  // estimated_cost_of_revenue
  // estimated-gross-profit
  // cost_incurred_to_date
  // billings_to_date
  // current_year_earned_revenue
  // current_year_contract_costs

  const getWipColumnHeaders = () => {
    return [
      "Contract Number",
      "Project Name",
      newData.labellerModel === "workInProgress"
        ? "Estimated Revenue"
        : "Total Earned Revenue",
      newData.labellerModel === "workInProgress"
        ? "Estimated Cost Of Revenue"
        : "Total Cost Of Revenue",
      newData.labellerModel === "workInProgress"
        ? "Estimated Gross Profit"
        : "Total Gross Profit",
      "Cost Incurred To Date",
      "Billings To Date",
      "Current Year Earned Revenue",
      "Current Year Contract Costs",
    ];
  };

  const addMissingLabels = () => {
    const matchedSplit = splitFilesData.find(
      (data) => data.splitFiles[0].id === newData.id,
    );

    let currentId = getNewestId(matchedSplit.splitFiles[0]);

    if (isFinancialDocument(matchedSplit.splitFiles[0].labellerModel)) {
      const unmatchedLabels = financialDocumentPropertyOrdering[
        newData.labellerModel
      ].filter(
        (label) =>
          label !== "reporting-dates" &&
          label !== "company-name" &&
          matchedSplit.splitFiles[0].labellerOutput.entities
            .filter((entity) => entity.type === "year")
            .every(
              (entity) =>
                !entity.properties.some((prop) => prop.type === label),
            ),
      );

      if (unmatchedLabels.length > 0) {
        console.log(
          "some labels are missing, adding them for financial document. ",
        );
        unmatchedLabels.forEach((label) => {
          setSplitFilesData((oldData) => {
            const updatedData = oldData.map((data) => {
              if (data.splitFiles[0].id === newData.id) {
                let entityIndices = [];

                getUniqueReportingYears(
                  newData.labellerOutput.entities,
                ).forEach((year) => {
                  const entityIndex =
                    data.splitFiles[0].labellerOutput.entities.findIndex(
                      (entity) => {
                        return entity.properties.find(
                          (property) =>
                            property.type === "reporting-year" &&
                            property.mentionText === year,
                        );
                      },
                    );

                  entityIndices.push(entityIndex);
                });

                const updatedEntities =
                  data.splitFiles[0].labellerOutput.entities.map(
                    (entity, index) => {
                      if (entityIndices.includes(index)) {
                        return {
                          ...entity,
                          properties: [
                            ...entity.properties,
                            {
                              id: (++currentId).toString(),
                              type: label,
                              mentionText: "0",
                            },
                          ],
                        };
                      }

                      return entity;
                    },
                  );

                return {
                  ...data,
                  splitFiles: [
                    {
                      ...data.splitFiles[0],
                      labellerOutput: {
                        ...data.splitFiles[0].labellerOutput,
                        entities: updatedEntities,
                      },
                    },
                  ],
                };
              }

              return data;
            });
            return updatedData;
          });
        });
      } else {
        console.log("all labels matched in entity properties.");
      }

      financialDocumentPropertyOrdering[newData.labellerModel].forEach(
        (label) => {
          let labelCounts = [];

          const years = getUniqueReportingYears(
            matchedSplit.splitFiles[0].labellerOutput.entities,
          );

          years.forEach((year, index) => {
            const matchedYearEntities =
              matchedSplit.splitFiles[0].labellerOutput.entities.filter(
                (entity) => {
                  return Boolean(
                    entity.properties?.find(
                      (prop) =>
                        prop.type === "reporting-year" &&
                        prop.mentionText === year,
                    ),
                  );
                },
              );

            const labelPropertyCount = matchedYearEntities
              .flatMap((entity) => entity.properties)
              .filter((prop) => prop.type === label).length;

            labelCounts.push({ count: labelPropertyCount, year });
          });

          const maxCount = Math.max(
            ...labelCounts.map((labelCount) => labelCount.count),
          );

          setSplitFilesData((oldData) => {
            return oldData.map((data) => {
              if (data.splitFiles[0].id === matchedSplit.splitFiles[0].id) {
                let currentId = getNewestId(data.splitFiles[0]);
                const entities = data.splitFiles[0].labellerOutput.entities;

                const years = getUniqueReportingYears(entities);

                const updatedEntities = [...entities];

                years.forEach((year) => {
                  const targetEntityIndex = updatedEntities.findIndex(
                    (entity) => {
                      if (entity.type !== "year") return false;
                      const reportingYearProp = entity.properties.find(
                        (prop) => prop.type === "reporting-year",
                      );
                      return (
                        reportingYearProp &&
                        reportingYearProp.mentionText === year
                      );
                    },
                  );

                  if (targetEntityIndex === -1) {
                    console.log(
                      `addMissingLabels: no entity found with reporting year ${year}`,
                    );
                    return;
                  }

                  const matchedLabelCount = labelCounts.find(
                    (labelCount) => labelCount.year === year,
                  );
                  if (!matchedLabelCount) {
                    console.log(
                      `addMissingLabels: matched label count not found for year ${year}`,
                    );
                    return;
                  }

                  const labelsToAdd = maxCount - matchedLabelCount.count;
                  console.log(
                    `${labelsToAdd} labels to add for ${label} for year ${year}`,
                  );

                  let missingProperties = [];
                  for (let i = 0; i < labelsToAdd; i++) {
                    missingProperties.push({
                      id: (++currentId).toString(),
                      type: label,
                      mentionText: "0",
                    });
                  }

                  const targetEntity = updatedEntities[targetEntityIndex];
                  updatedEntities[targetEntityIndex] = {
                    ...targetEntity,
                    properties: [
                      ...targetEntity.properties,
                      ...missingProperties,
                    ],
                  };
                });

                return {
                  ...data,
                  splitFiles: [
                    {
                      ...data.splitFiles[0],
                      labellerOutput: {
                        ...data.splitFiles[0].labellerOutput,
                        entities: updatedEntities,
                      },
                    },
                  ],
                };
              }
              return data;
            });
          });
        },
      );
    } else {
      console.log("some labels are missing, adding them for wip/wc document. ");
    }
  };

  useEffect(() => {
    addMissingLabels();
  }, []);

  useEffect(() => {
    console.log("called create entries hook. ");

    const matchedSplit = splitFilesData.find(
      (data) => data.splitFiles[0].id === newData.id,
    );

    setEntries(() => {
      if (isFinancialDocument(newData.labellerModel)) {
        const entryData = financialDocumentPropertyOrdering[
          newData.labellerModel
        ].map((prop) => {
          let matchedProperties = [];

          if (!matchedSplit) {
            console.log("Split does not exist. ");
            return;
          }

          // console.log("matched split ", matchedSplit);

          matchedSplit.splitFiles[0].labellerOutput.entities
            .filter((entity) => entity.type === "year")
            .forEach((entity) => {
              const year = entity.properties.find(
                (p) => p.type === "reporting-year",
              ).mentionText;

              const matchedProps = entity.properties.filter(
                (p) => p.type === prop,
              );

              if (matchedProps.length > 0) {
                matchedProps.forEach((p) => {
                  matchedProperties.push({
                    year,
                    propertyId: p.id,
                    entityId: entity.id,
                  });
                });
              }
            });

          matchedProperties.sort((a, b) => a.id - b.id);

          return {
            label: prop,
            propertyData: matchedProperties,
          };
        });

        entryData.forEach((entry) => {
          let rowData = [];
          let rowCount = 0;

          getUniqueReportingYears(newData.labellerOutput.entities).forEach(
            (year) => {
              const matches = entry.propertyData.filter((p) => p.year === year);

              if (matches.length > rowCount) {
                rowCount = matches.length;
              }
            },
          );

          [...Array(rowCount).keys()].forEach(() => {
            rowData.push([]);
          });

          getUniqueReportingYears(newData.labellerOutput.entities).forEach(
            (year) => {
              const matches = entry.propertyData.filter((p) => p.year === year);
              matches.sort((a, b) => a.propertyId - b.propertyId);

              rowData.forEach((row, i) => {
                rowData[i].push(matches[i]);
              });
            },
          );

          entry.rowData = rowData;
          // console.log(
          //   "entrylabel",
          //   entry.label,
          //   "entryrowdata ",
          //   entry.rowData,
          // );
        });
        //
        // console.log("entries ", entryData);
        // console.log("split files data ", splitFilesData);
        return entryData;
      }

      if (isWipOrWorkCompletedDocument(newData.labellerModel)) {
        const newEntries = matchedSplit.splitFiles[0].labellerOutput.entities
          .map((entity) => {
            if (entity.type === "project") {
              const contract_number =
                entity.properties.find(
                  (property) => property.type === "contract_number",
                )?.mentionText || "0";
              const project_name =
                entity.properties.find(
                  (property) => property.type === "project_name",
                )?.mentionText || "0";
              const estimated_revenue =
                entity.properties.find((property) =>
                  newData.labellerModel === "workInProgress"
                    ? property.type === "estimated_revenue"
                    : property.type === "project_value_or_estimated_revenue",
                )?.mentionText || "0";
              const estimated_cost_of_revenue =
                entity.properties.find(
                  (property) => property.type === "estimated_cost_of_revenue",
                )?.mentionText || "0";
              const estimated_gross_profit =
                entity.properties.find(
                  (property) => property.type === "estimated-gross-profit",
                )?.mentionText || "0";
              const cost_incurred_to_date =
                entity.properties.find(
                  (property) => property.type === "cost_incurred_to_date",
                )?.mentionText || "0";
              const billings_to_date =
                entity.properties.find(
                  (property) => property.type === "billings_to_date",
                )?.mentionText || "0";
              const current_year_earned_revenue =
                entity.properties.find(
                  (property) => property.type === "current_year_earned_revenue",
                )?.mentionText || "0";
              const current_year_contract_costs =
                entity.properties.find(
                  (property) => property.type === "current_year_contract_costs",
                )?.mentionText || "0";

              return {
                entityId: entity.id,
                contract_number,
                project_name,
                estimated_revenue,
                estimated_cost_of_revenue,
                estimated_gross_profit,
                cost_incurred_to_date,
                billings_to_date,
                current_year_earned_revenue,
                current_year_contract_costs,
              };
            }
          })
          .filter((entry) => entry !== undefined);

        // console.log("new entries", newEntries);

        return newEntries;
      }
    });
  }, [splitFilesData]);

  const handleWipLabelUpdate = (entityId, propertyType, updatedValue) => {
    const matchedSplit = splitFilesData.find(
      (data) => data.splitFiles[0].id === newData.id,
    );

    let currentId = getNewestId(matchedSplit.splitFiles[0]);

    const matchedProperty =
      matchedSplit?.splitFiles?.[0]?.labellerOutput?.entities
        ?.find((entity) => entity.id === entityId)
        ?.properties?.find((property) => property.type === propertyType) ||
      null;

    if (!matchedProperty) {
      console.log(
        `No matching property found, appending new property of type ${propertyType} to entity with ID: ${entityId}`,
      );
      setSplitFilesData((oldData) => {
        const updatedData = oldData.map((data) => {
          const updatedEntities =
            data.splitFiles[0].labellerOutput.entities.map((entity) => {
              console.log("ids ");
              const matchingSplit = data.splitFiles[0].id === newData.id;
              const matchingEntity = entity.id === entityId;
              if (matchingSplit && matchingEntity) {
                const newProperty = {
                  id: (++currentId).toString(),
                  type: propertyType,
                  mentionText: updatedValue,
                };

                return {
                  ...entity,
                  properties: [...entity.properties, newProperty],
                };
              }
              return entity;
            });

          return {
            ...data,
            splitFiles: [
              {
                ...data.splitFiles[0],
                labellerOutput: {
                  ...data.splitFiles[0].labellerOutput,
                  entities: updatedEntities,
                },
              },
            ],
          };
        });

        console.log("Updated data after adding missing property:", updatedData);
        return updatedData;
      });

      return;
    }

    setSplitFilesData((oldData) => {
      const updatedData = oldData.map((data) => {
        // Ensure splitFiles exists
        if (!data.splitFiles?.[0]) return data;

        const updatedEntities = data.splitFiles[0].labellerOutput.entities.map(
          (entity) => {
            if (
              entity.id === entityId &&
              data.splitFiles[0].id === newData.id
            ) {
              const updatedProperties = entity.properties.map((property) => {
                if (property.type === propertyType) {
                  return {
                    ...property,
                    mentionText: updatedValue,
                  };
                }
                return property;
              });

              return {
                ...entity,
                properties: updatedProperties,
              };
            }
            return entity;
          },
        );

        return {
          ...data,
          splitFiles: [
            {
              ...data.splitFiles[0],
              labellerOutput: {
                ...data.splitFiles[0].labellerOutput,
                entities: updatedEntities,
              },
            },
          ],
        };
      });

      console.log("Updated data:", updatedData);
      return updatedData;
    });
  };

  return (
    <>
      <Dialog
        open={showDeleteConfirmationPopup}
        setOpen={setShowDeleteConfirmationPopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
      >
        <StyledPaper elevation={0}>
          <CloseButton
            aria-label="close"
            onClick={() => {
              setShowDeleteConfirmationPopup(false);
              setPropertyToDelete({
                property: null,
                type: null,
                entityIndex: null,
              });
            }}
          >
            <CloseIcon />
          </CloseButton>
          <img src={PylonIcon} />
          <FormTitle
            style={{
              marginTop: "18px",
              marginBottom: "18px",
              color: "#1A051D",
              fontSize: "22px",
              fontWeight: "600",
              fontStyle: "normal",
              lineHeight: "24px",
            }}
          >
            Confirm Deletion
          </FormTitle>
          <SmallTitleText
            style={{
              marginBottom: 10,
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
          >
            {(() => {
              const { property, type, entity } = propertyToDelete;

              if (!type || !entity) {
                return "Missing type and entity, please try again later.";
              }

              if ((type === "year" || type === "project") && !property) {
                return "Missing property, please try again later.";
              }

              if (type === "year" || type === "project") {
                if (!entity)
                  return "Entity data is missing, please try again later.";

                const contextText =
                  type === "year" ? (
                    <>
                      reporting year{" "}
                      <strong>
                        {entity.properties.find(
                          (prop) => prop.type === "reporting-year",
                        )?.mentionText || "Unknown year"}
                      </strong>
                    </>
                  ) : (
                    <>
                      project name{" "}
                      <strong>
                        {entity.properties.find(
                          (prop) => prop.type === "project_name",
                        )?.mentionText || "Unknown project name"}
                      </strong>
                    </>
                  );

                return (
                  <>
                    Are you sure you want to delete the label{" "}
                    <strong>{property.type}</strong> with the value{" "}
                    <strong>{property.mentionText}</strong> under the{" "}
                    {contextText}?
                  </>
                );
              } else {
                return (
                  <>
                    Are you sure you want to delete the label{" "}
                    <strong>{entity.type}</strong> with the value{" "}
                    <strong>{entity.mentionText}</strong>?
                  </>
                );
              }
            })()}
          </SmallTitleText>
          <InfoArea>
            <FunctionalButton
              buttonTitle="Confirm"
              handleButton={() => {
                const updatedSplitFiles = splitFilesData.map((file) =>
                  file.splitFiles[0].id === newData.id
                    ? { ...file, isEdited: true }
                    : file,
                );

                setSplitFilesData(
                  updatedSplitFiles.map((file) => {
                    if (file.splitFiles[0].id === newData.id) {
                      const updatedEntities =
                        file.splitFiles[0].labellerOutput.entities.map(
                          (entity) => {
                            if (entity.id === propertyToDelete.entity.id) {
                              if (propertyToDelete.type === "project") {
                                return {
                                  ...entity,
                                  properties: entity.properties.filter(
                                    (p) =>
                                      p.id !== propertyToDelete.property.id,
                                  ),
                                };
                              } else if (propertyToDelete.type === "year") {
                                return {
                                  ...entity,
                                  properties: entity.properties.filter(
                                    (p) =>
                                      p.id !== propertyToDelete.property.id,
                                  ),
                                };
                              }
                            }
                            return entity;
                          },
                        );

                      const filteredEntities =
                        propertyToDelete.type === "year" ||
                        propertyToDelete.type === "project"
                          ? updatedEntities
                          : file.splitFiles[0].labellerOutput.entities.filter(
                              (entity) =>
                                entity.id !== propertyToDelete.entity.id,
                            );

                      setNewData({
                        ...file.splitFiles[0],
                        labellerOutput: {
                          ...file.splitFiles[0].labellerOutput,
                          entities: filteredEntities,
                        },
                      });

                      return {
                        ...file,
                        splitFiles: [
                          {
                            ...file.splitFiles[0],
                            labellerOutput: {
                              ...file.splitFiles[0].labellerOutput,
                              entities: filteredEntities,
                            },
                          },
                        ],
                      };
                    }
                    return file;
                  }),
                );

                setShowDeleteConfirmationPopup(false);
              }}
              width="308px"
              height="48px"
              isReversedColor={false}
              marginRight={"48px"}
              marginLeft={"48px"}
              marginTop={"30px"}
              marginBottom={"20px"}
              fontSize={"18px"}
              disabled={false}
              icon={null}
              hasBoxShadow={true}
              frontIcon={null}
              weight={600}
            />
          </InfoArea>
        </StyledPaper>
      </Dialog>
      <ScreenRoot>
        <AlertPopup
          headerText="Failed to save your field changes"
          height="434px"
          subHeaderText="The was an error saving your field changes."
          openPopup={showSaveFieldChangesFailedPopup}
          setOpenPopup={setShowSaveFieldChangesFailedPopup}
          showIcon={true}
          width={"640px"}
          showButton={false}
        />
        <Dialog
          open={showSaveFieldChangesSuccessPopup}
          setOpen={setShowSaveFieldChangesSuccessPopup}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="md"
        >
          <StyledPaper elevation={0}>
            <CloseButton
              aria-label="close"
              onClick={() => {
                setShowSaveFieldChangesSuccessPopup(false);
              }}
            >
              <CloseIcon />
            </CloseButton>
            <Success />
            <FormTitle
              style={{
                marginTop: "10px",
                color: "#1A051D",
                fontSize: "22px",
                fontWeight: "600",
                fontStyle: "normal",
                lineHeight: "24px",
              }}
            >
              Saved
            </FormTitle>
            <SmallTitleText
              style={{
                marginBottom: 10,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100%",
              }}
            >
              Your field changes have been saved
            </SmallTitleText>
            <InfoArea>
              <FunctionalButton
                buttonTitle="Close"
                handleButton={() => {
                  setShowSaveFieldChangesSuccessPopup(false);
                }}
                width="308px"
                height="48px"
                isReversedColor={false}
                marginRight={"48px"}
                marginLeft={"48px"}
                marginTop={"30px"}
                marginBottom={"20px"}
                fontSize={"18px"}
                disabled={false}
                icon={null}
                hasBoxShadow={true}
                frontIcon={null}
                weight={600}
              />
            </InfoArea>
          </StyledPaper>
        </Dialog>
        {editingFieldData && (
          <>
            <Dialog
              open={showEditFieldPopup}
              setOpen={setShowEditFieldPopup}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              PaperProps={{
                style: {
                  minWidth: "80vw",
                  width: "80vw",
                  margin: 0,
                  overflow: "hidden",
                },
              }}
            >
              <StyledPaper
                elevation={0}
                style={{
                  overflow: "hidden",
                  padding: "20px",
                  width: "80vw",
                }}
              >
                <div style={{ margin: "30px 0" }}>
                  <CloseButton aria-label="close" onClick={handleClose}>
                    <CloseIcon />
                  </CloseButton>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "50px",
                    width: "100%",
                  }}
                >
                  <div style={{ width: "50%" }}>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <PledgxLogo />
                    </div>
                    <FormTitle
                      style={{
                        marginTop: "10px",
                        color: "#1A051D",
                        fontSize: "22px",
                        fontWeight: "600",
                        fontStyle: "normal",
                        lineHeight: "24px",
                        textAlign: "center",
                      }}
                    >
                      {editingFieldData.mode === "edit" ? "Edit" : "New"} Field
                    </FormTitle>
                    <SmallTitleText
                      style={{
                        marginBottom: 10,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                      }}
                    >
                      {modelMappings[newData.labellerModel]}
                    </SmallTitleText>
                    <InfoArea marginTop="0px">
                      <div
                        style={{
                          margin: "0px",
                          marginBottom: "-15px",
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                        }}
                      >
                        <Select
                          label="Select the type of this label"
                          options={(() => {
                            if (editingFieldData.mode === "new") {
                              if (
                                editingFieldData.entity.year ===
                                "New Reporting Year"
                              ) {
                                return [
                                  {
                                    label: "reporting-year",
                                    value: "reporting-year",
                                  },
                                ];
                              }
                              if (
                                editingFieldData.entity.project ===
                                "New Project"
                              ) {
                                return [
                                  {
                                    label: "project_name",
                                    value: "project_name",
                                  },
                                ];
                              }
                            }

                            return isWipOrWorkCompletedDocument(
                              newData.labellerModel,
                            )
                              ? [
                                  {
                                    value: "as_of_date",
                                    label: "as_of_date",
                                  },
                                  {
                                    value: "company_name",
                                    label: "company_name",
                                  },
                                  {
                                    value: "project_status",
                                    label: "project_status",
                                  },
                                ]
                              : [
                                  {
                                    value: "reporting-dates",
                                    label: "reporting-dates",
                                  },
                                  {
                                    value: "company-name",
                                    label: "company-name",
                                  },
                                ];
                          })()}
                          value={(() => {
                            let value;

                            const doesEntityOrPropertyCopyExist =
                              editingFieldData.entity ||
                              editingFieldData.propertyCopy;
                            const entityType = editingFieldData?.entity?.type;
                            const propertyCopyType =
                              editingFieldData?.propertyCopy?.type;

                            if (doesEntityOrPropertyCopyExist) {
                              if (entityType) {
                                // when new field
                                value = entityType;
                              } else if (propertyCopyType) {
                                // when editing field
                                value = propertyCopyType;
                              }
                            } else {
                              value = editingFieldData.type;
                            }

                            return value;
                          })()}
                          setValue={(val) => {
                            if (editingFieldData.entity) {
                              // when new field
                              setEditingFieldData((prevState) => ({
                                ...prevState,
                                entity: {
                                  ...prevState.entity,
                                  type: val,
                                },
                              }));
                            } else {
                              // when editing field
                              setEditingFieldData((prevState) => ({
                                ...prevState,
                                propertyCopy: {
                                  ...prevState.propertyCopy,
                                  type: val,
                                },
                              }));
                            }
                          }}
                          validateFunc={(item) => Boolean(item)}
                          noCheckIcon={true}
                          showDropdownIndicator={true}
                        />

                        <Input
                          id="oneThirdInputWrap"
                          label={
                            editingFieldData.mode === "edit"
                              ? "Edit value"
                              : "Enter value"
                          }
                          type="text"
                          placeholder="0"
                          labelSize="12px"
                          fontSize="18px"
                          value={
                            editingFieldData?.entity?.mentionText ||
                            editingFieldData?.propertyCopy?.mentionText
                          }
                          setValue={(val) => {
                            if (editingFieldData.entity) {
                              setEditingFieldData((prevState) => ({
                                ...prevState,
                                entity: {
                                  ...prevState.entity,
                                  mentionText: val,
                                },
                              }));
                            }
                            if (editingFieldData.propertyCopy) {
                              setEditingFieldData((prevState) => ({
                                ...prevState,
                                propertyCopy: {
                                  ...prevState.propertyCopy,
                                  mentionText: val,
                                },
                              }));
                            }
                            //console.log("edit mode finish ", editingFieldData);
                          }}
                          noCheckIcon={true}
                          noErrorBorder={true}
                          style={{ width: "100%", paddingRight: "0px" }}
                        />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <FunctionalButton
                            buttonTitle="Confirm"
                            handleButton={updateSplitWithNewOrEditedFieldData}
                            width="308px"
                            height="48px"
                            isReversedColor={false}
                            marginRight={"48px"}
                            marginLeft={"48px"}
                            marginTop={"30px"}
                            marginBottom={"20px"}
                            fontSize={"18px"}
                            disabled={false}
                            icon={null}
                            hasBoxShadow={true}
                            frontIcon={null}
                            weight={600}
                          />
                        </div>
                      </div>
                    </InfoArea>
                  </div>
                  <div style={{ width: "95%" }}>
                    <iframe
                      src={pdfSrc}
                      title="PDF Viewer"
                      width="100%"
                      height="700px"
                    />
                    {/*<DocumentViewer src={pdfSrc} />*/}
                  </div>
                </div>
              </StyledPaper>
            </Dialog>
          </>
        )}
        <HorizontalContainer>
          <div
            style={{
              width: isFinancialDocument(newData.labellerModel)
                ? "50%"
                : "100%",
              height: "90vh",
            }}
          >
            <div style={{ display: "flex" }}>
              <BackButtonContainer>
                <BackButton onClick={handleBackClick}>
                  {"< Back to Parser List"}
                </BackButton>
              </BackButtonContainer>
              <FunctionalButton
                buttonTitle="Save Changes"
                handleButton={() => handleSaveChanges()}
                width="200px"
                height="48px"
                isReversedColor={false}
                marginRight={"48px"}
                marginLeft={"48px"}
                marginTop={"30px"}
                marginBottom={"20px"}
                fontSize={"14px"}
                disabled={false}
                icon={null}
                hasBoxShadow={true}
                frontIcon={null}
                weight={600}
              />
            </div>

            {isWipOrWorkCompletedDocument(newData.labellerModel) && (
              <div style={{ width: "100%", height: "40%" }}>
                <iframe
                  src={pdfSrc}
                  title="PDF Viewer"
                  width="100%"
                  height="100%"
                />
              </div>
            )}

            {isWipOrWorkCompletedDocument(newData.labellerModel) ? (
              <StyledTable>
                <StyledTableRow>
                  {splitFilesData
                    .find((data) => data.splitFiles[0].id === newData.id)
                    .splitFiles[0].labellerOutput.entities.filter(
                      (entity) =>
                        entity.type !== "year" && entity.type !== "project",
                    )
                    .reduce((accumulator, entity) => {
                      const existingEntityIndex = accumulator.findIndex(
                        (e) =>
                          e.type === entity.type &&
                          e.mentionText === entity.mentionText,
                      );

                      if (existingEntityIndex === -1) {
                        accumulator.push(entity);
                      }

                      return accumulator;
                    }, [])
                    .map((entity) => (
                      <StyledTableCell key={entity.id}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "6px",
                          }}
                        >
                          <div>
                            {friendlyLabelMappings[entity.type] || entity.type}
                          </div>
                          <ValueInput
                            value={(() => {
                              return entity.mentionText;
                            })()}
                            onFocus={(event) => {
                              const currentValue = event.target.value;
                              if (currentValue === "0") {
                                event.target.select();
                              }
                            }}
                            onChange={(event) => {
                              const updatedValue = event.target.value;

                              const matchedSplit = splitFilesData.find(
                                (data) => data.splitFiles[0].id === newData.id,
                              );

                              setSplitFilesData((oldData) => {
                                return oldData.map((data) => {
                                  if (
                                    data.splitFiles[0].id ===
                                    matchedSplit.splitFiles[0].id
                                  ) {
                                    const updatedEntities =
                                      data.splitFiles[0].labellerOutput.entities.map(
                                        (e) => {
                                          if (e.id === entity.id) {
                                            return {
                                              ...entity,
                                              mentionText: updatedValue,
                                            };
                                          }
                                          return e;
                                        },
                                      );

                                    return {
                                      ...data,
                                      splitFiles: [
                                        {
                                          ...data.splitFiles[0],
                                          labellerOutput: {
                                            ...data.splitFiles[0]
                                              .labellerOutput,
                                            entities: updatedEntities,
                                          },
                                        },
                                      ],
                                    };
                                  }
                                  return data;
                                });
                              });
                            }}
                          ></ValueInput>
                        </div>
                      </StyledTableCell>
                    ))}
                </StyledTableRow>
              </StyledTable>
            ) : (
              <StyledTable>
                {splitFilesData
                  .find((data) => data.splitFiles[0].id === newData.id)
                  .splitFiles[0]?.labellerOutput?.entities?.filter(
                    (entity) =>
                      entity.type !== "year" && entity.type !== "project",
                  )
                  .reduce((accumulator, entity) => {
                    const existingEntityIndex = accumulator.findIndex(
                      (e) =>
                        e.type === entity.type &&
                        e.mentionText === entity.mentionText,
                    );

                    console.log("eei ", existingEntityIndex);

                    if (existingEntityIndex === -1) {
                      accumulator.push(entity);
                    }

                    return accumulator;
                  }, [])
                  .map((entity) => {
                    const filteredEntities = splitFilesData
                      .find((data) => data.splitFiles[0].id === newData.id)
                      .splitFiles[0]?.labellerOutput?.entities?.filter(
                        (entity) =>
                          entity.type !== "year" && entity.type !== "project",
                      )
                      .reduce((accumulator, entity) => {
                        const existingEntityIndex = accumulator.findIndex(
                          (e) =>
                            e.type === entity.type &&
                            e.mentionText === entity.mentionText,
                        );

                        if (existingEntityIndex === -1) {
                          accumulator.push(entity);
                        }

                        return accumulator;
                      }, []);
                    
                    const entitiesOfSameType = filteredEntities.filter(
                      (e) => e.type === entity.type
                    );
                    
                    const hasMultipleFieldsOfSameType = entitiesOfSameType.length > 1;
                    
                    return (
                      <StyledTableRow key={entity.id}>
                        <StyledTableCell>
                          {friendlyLabelMappings[entity.type] || entity.type}
                        </StyledTableCell>
                        <StyledTableCell>
                          <ValueInput
                            value={(() => {
                              return entity.mentionText;
                            })()}
                            onFocus={(event) => {
                              const currentValue = event.target.value;
                              if (currentValue === "0") {
                                event.target.select();
                              }
                            }}
                            onChange={(event) => {
                              const updatedValue = event.target.value;

                              const matchedSplit = splitFilesData.find(
                                (data) => data.splitFiles[0].id === newData.id,
                              );

                              setSplitFilesData((oldData) => {
                                return oldData.map((data) => {
                                  if (
                                    data.splitFiles[0].id ===
                                    matchedSplit.splitFiles[0].id
                                  ) {
                                    const updatedEntities =
                                      data.splitFiles[0].labellerOutput.entities.map(
                                        (e) => {
                                          if (e.id === entity.id) {
                                            return {
                                              ...entity,
                                              mentionText: updatedValue,
                                            };
                                          }
                                          return e;
                                        },
                                      );

                                    return {
                                      ...data,
                                      splitFiles: [
                                        {
                                          ...data.splitFiles[0],
                                          labellerOutput: {
                                            ...data.splitFiles[0].labellerOutput,
                                            entities: updatedEntities,
                                          },
                                        },
                                      ],
                                    };
                                  }
                                  return data;
                                });
                              });
                            }}
                          ></ValueInput>
                        </StyledTableCell>
                        {hasMultipleFieldsOfSameType && (
                          <StyledTableCell>
                            <ActionButton
                              onClick={() => {
                                const matchedSplit = splitFilesData.find(
                                  (data) => data.splitFiles[0].id === newData.id,
                                );

                                setSplitFilesData((oldData) => {
                                  return oldData.map((data) => {
                                    if (
                                      data.splitFiles[0].id ===
                                      matchedSplit.splitFiles[0].id
                                    ) {
                                      const updatedEntities =
                                        data.splitFiles[0].labellerOutput.entities.filter(
                                          (e) => e.id !== entity.id
                                        );

                                      return {
                                        ...data,
                                        splitFiles: [
                                          {
                                            ...data.splitFiles[0],
                                            labellerOutput: {
                                              ...data.splitFiles[0].labellerOutput,
                                              entities: updatedEntities,
                                            },
                                          },
                                        ],
                                      };
                                    }
                                    return data;
                                  });
                                });
                              }}
                            >
                              <DeleteIcon />
                            </ActionButton>
                          </StyledTableCell>
                        )}
                      </StyledTableRow>
                    );
                  })}
              </StyledTable>
            )}

            {isFinancialDocument(newData.labellerModel) ? (
              <div style={{ height: "85%", overflowY: "auto" }}>
                <StyledTable
                  style={{
                    borderCollapse: "separate",
                    borderSpacing: 0,
                    padding: "0",
                  }}
                >
                  <colgroup>
                    <col style={{ width: "45%" }} />
                    <col style={{ width: "20%" }} />
                    <col style={{ width: "20%" }} />
                  </colgroup>
                  <thead>
                    <StyledTableRow
                      header={true}
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                        backgroundColor: "white",
                      }}
                    >
                      <StyledTableCell header={true}>Label</StyledTableCell>
                      {getUniqueReportingYears(
                        newData.labellerOutput.entities,
                      ).map((year) => (
                        <StyledTableCell
                          key={year}
                          style={{ textAlign: "right" }}
                        >
                          <strong>{year}</strong>
                        </StyledTableCell>
                      ))}
                      <StyledTableCell header={true}>Actions</StyledTableCell>
                    </StyledTableRow>
                  </thead>
                  <tbody>
                    {entries
                      .filter(
                        (entry) =>
                          entry.label !== "company-name" &&
                          entry.label !== "reporting-dates" &&
                          entry.label !== "reporting-year",
                      )
                      .map((entry, entryIndex) => {
                        const labelNotReturnedByModel =
                          entry.rowData.length === 0;
                        if (labelNotReturnedByModel) {
                          return (
                            <StyledTableRow key={`entry-${entryIndex}`}>
                              <StyledTableCell>
                                <strong>
                                  {friendlyLabelMappings[entry.label]}
                                </strong>
                              </StyledTableCell>
                              {getUniqueReportingYears(
                                newData.labellerOutput.entities,
                              ).map((year) => (
                                <StyledTableCell style={{ textAlign: "right" }}>
                                  <ValueInput 
                                    value={0} 
                                    onFocus={(event) => {
                                      const currentValue = event.target.value;
                                      if (currentValue === "0") {
                                        event.target.select();
                                      }
                                    }}
                                  />
                                </StyledTableCell>
                              ))}
                              <StyledTableCell>
                                <ActionButton
                                  onClick={() => {
                                    let currentId = getNewestId(
                                      splitFilesData.find(
                                        (data) =>
                                          data.splitFiles[0].id === newData.id,
                                      ).splitFiles[0],
                                    );

                                    let yearEntityIds = [];

                                    getUniqueReportingYears(
                                      newData.labellerOutput.entities,
                                    ).forEach((year) => {
                                      const yearEntity =
                                        newData.labellerOutput.entities.find(
                                          (entity) => {
                                            return entity.properties.find(
                                              (property) => {
                                                if (
                                                  property.type ===
                                                    "reporting-year" &&
                                                  property.mentionText === year
                                                ) {
                                                  return entity;
                                                }
                                              },
                                            );
                                          },
                                        );

                                      if (yearEntity) {
                                        yearEntityIds.push(yearEntity.id);
                                      }
                                    });

                                    setSplitFilesData((oldData) => {
                                      const updatedNewData = oldData.map(
                                        (data) => {
                                          console.log("olddata", data);
                                          console.log("newdata", newData);

                                          if (
                                            data.splitFiles[0].id === newData.id
                                          ) {
                                            const newEntities =
                                              data.splitFiles[0].labellerOutput.entities.map(
                                                (entity) => {
                                                  if (
                                                    yearEntityIds.includes(
                                                      entity.id,
                                                    )
                                                  ) {
                                                    entity.properties.push({
                                                      id: (++currentId).toString(),
                                                      type: entry.label,
                                                      mentionText: "0",
                                                      confidence: 1,
                                                    });
                                                  }

                                                  return entity;
                                                },
                                              );

                                            return {
                                              ...data,
                                              splitFiles: [
                                                {
                                                  ...data.splitFiles[0],
                                                  labellerOutput: {
                                                    ...data.labellerOutput,
                                                    entities: newEntities,
                                                  },
                                                },
                                              ],
                                            };
                                          } else {
                                            return data;
                                          }
                                        },
                                      );
                                      return updatedNewData;
                                    });
                                  }}
                                >
                                  +
                                </ActionButton>
                              </StyledTableCell>
                            </StyledTableRow>
                          );
                        }
                        return entry.rowData.map((row, rowIndex) => {
                          return (
                            <StyledTableRow>
                              <StyledTableCell>
                                <strong>
                                  {friendlyLabelMappings[entry.label]}
                                </strong>
                              </StyledTableCell>
                              {row.map((rowData, rowDataIndex) => {
                                return rowData ? (
                                  <StyledTableCell
                                    style={{ textAlign: "right" }}
                                  >
                                    {/*MentionText Values*/}
                                    <ValueInput
                                      onMouseEnter={() => {
                                        try {
                                          const matchedSplit =
                                            splitFilesData.find(
                                              (data) =>
                                                data.splitFiles[0].id ===
                                                newData.id,
                                            );

                                          if (!matchedSplit)
                                            throw new Error(
                                              "Matching split not found",
                                            );

                                          const entity =
                                            matchedSplit.splitFiles[0].labellerOutput.entities.find(
                                              (e) => e.id === rowData.entityId,
                                            );

                                          if (!entity)
                                            throw new Error(
                                              `Entity with id ${rowData.entityId} not found`,
                                            );

                                          const property =
                                            entity.properties.find(
                                              (e) =>
                                                e.id === rowData.propertyId,
                                            );

                                          if (!property) {
                                            console.error(
                                              `Property with id ${rowData.propertyId} not found`,
                                            );
                                          }

                                          console.log("Property ", property);
                                          // setHoveredLabel({
                                          //   x: property.pageAnchor.pageRefs[0]
                                          //     .boundingPoly
                                          //     .normalizedVertices[0].x,
                                          //   y: property.pageAnchor.pageRefs[0]
                                          //     .boundingPoly
                                          //     .normalizedVertices[0].y,
                                          //   width:
                                          //     property.pageAnchor.pageRefs[0]
                                          //       .boundingPoly
                                          //       .normalizedVertices[2].x -
                                          //     property.pageAnchor.pageRefs[0]
                                          //       .boundingPoly
                                          //       .normalizedVertices[0].x,
                                          //   height:
                                          //     property.pageAnchor.pageRefs[0]
                                          //       .boundingPoly
                                          //       .normalizedVertices[2].y -
                                          //     property.pageAnchor.pageRefs[0]
                                          //       .boundingPoly
                                          //       .normalizedVertices[0].y,
                                          // });
                                        } catch (error) {
                                          console.error(
                                            "Error in ValueInput:",
                                            error,
                                          );
                                          return "Error loading data";
                                        }
                                      }}
                                      onFocus={(event) => {
                                        const currentValue = event.target.value;
                                        if (currentValue === "0") {
                                          event.target.select();
                                        }
                                      }}
                                      value={(() => {
                                        try {
                                          const matchedSplit =
                                            splitFilesData.find(
                                              (data) =>
                                                data.splitFiles[0].id ===
                                                newData.id,
                                            );

                                          if (!matchedSplit)
                                            throw new Error(
                                              "Matching split not found",
                                            );

                                          const entity =
                                            matchedSplit.splitFiles[0].labellerOutput.entities.find(
                                              (e) => e.id === rowData.entityId,
                                            );

                                          if (!entity)
                                            throw new Error(
                                              `Entity with id ${rowData.entityId} not found`,
                                            );

                                          const property =
                                            entity.properties.find(
                                              (e) =>
                                                e.id === rowData.propertyId,
                                            );

                                          if (!property) {
                                            console.error(
                                              `Property with id ${rowData.propertyId} not found`,
                                            );
                                          }

                                          return property.mentionText || "0";
                                        } catch (error) {
                                          console.error(
                                            "Error in ValueInput:",
                                            error,
                                          );
                                          return "Error loading data";
                                        }
                                      })()}
                                      onChange={(event) => {
                                        const updatedSplitFiles =
                                          splitFilesData.map((file) =>
                                            file.splitFiles[0].id === newData.id
                                              ? { ...file, isEdited: true }
                                              : file,
                                          );
                                        setSplitFilesData(updatedSplitFiles);

                                        const updatedValue = event.target.value;
                                        console.log(
                                          "Updated value:",
                                          updatedValue,
                                        );

                                        setSplitFilesData((oldData) => {
                                          console.log("Old data:", oldData);

                                          const updatedData = oldData.map(
                                            (data) => {
                                              console.log(
                                                "Processing data:",
                                                data,
                                              );

                                              if (
                                                data.splitFiles[0].id ===
                                                newData.id
                                              ) {
                                                console.log(
                                                  "Match found for newData.id:",
                                                  newData.id,
                                                );

                                                const updatedEntities =
                                                  data.splitFiles[0].labellerOutput.entities.map(
                                                    (entity) => {
                                                      console.log(
                                                        "Processing entity:",
                                                        entity,
                                                      );

                                                      if (
                                                        entity.id ===
                                                        rowData.entityId
                                                      ) {
                                                        console.log(
                                                          "Match found for entity.id:",
                                                          entity.id,
                                                        );

                                                        const updatedProperties =
                                                          entity.properties.map(
                                                            (property) => {
                                                              console.log(
                                                                "Processing property:",
                                                                property,
                                                              );

                                                              if (
                                                                property.id ===
                                                                rowData.propertyId
                                                              ) {
                                                                console.log(
                                                                  `Updating property.id: ${property.id}, with new mentionText: ${updatedValue}`,
                                                                );
                                                                return {
                                                                  ...property,
                                                                  mentionText:
                                                                    updatedValue,
                                                                };
                                                              }
                                                              return property;
                                                            },
                                                          );

                                                        return {
                                                          ...entity,
                                                          properties:
                                                            updatedProperties,
                                                        };
                                                      } else {
                                                        console.log("No match");
                                                      }

                                                      return entity;
                                                    },
                                                  );

                                                return {
                                                  ...data,
                                                  splitFiles: [
                                                    {
                                                      ...data.splitFiles[0],
                                                      labellerOutput: {
                                                        ...data.splitFiles[0]
                                                          .labellerOutput,
                                                        entities:
                                                          updatedEntities,
                                                      },
                                                    },
                                                  ],
                                                };
                                              }

                                              console.log(
                                                "No match for newData.id:",
                                                newData.id,
                                              );
                                              return data;
                                            },
                                          );

                                          console.log(
                                            "Updated splitFilesData:",
                                            updatedData,
                                          );
                                          return updatedData;
                                        });
                                      }}
                                    />
                                  </StyledTableCell>
                                ) : (
                                  <StyledTableCell
                                    style={{ textAlign: "right" }}
                                  >
                                    <ValueInput
                                      value={"No Data"}
                                      onFocus={(event) => {
                                        const currentValue = event.target.value;
                                        if (currentValue === "0") {
                                          event.target.select();
                                        }
                                      }}
                                      onChange={console.log}
                                    />
                                  </StyledTableCell>
                                );
                              })}
                              <StyledTableCell>
                                <ActionButton
                                  onClick={() => {
                                    try {
                                      const currentSplit = splitFilesData.find(
                                        (data) =>
                                          data.splitFiles[0].id === newData.id,
                                      );

                                      if (!currentSplit) {
                                        console.error(
                                          "Error: No matching split found for newData.id:",
                                          newData.id,
                                        );
                                        return;
                                      }

                                      let currentId;
                                      try {
                                        currentId = getNewestId(
                                          currentSplit.splitFiles[0],
                                        );
                                      } catch (error) {
                                        console.error(
                                          "Error in getNewestId:",
                                          error,
                                        );
                                        return;
                                      }

                                      let yearEntityIds = [];

                                      try {
                                        getUniqueReportingYears(
                                          newData.labellerOutput.entities,
                                        ).forEach((year) => {
                                          const yearEntity =
                                            newData.labellerOutput.entities.find(
                                              (entity) => {
                                                return entity.properties.find(
                                                  (property) => {
                                                    if (
                                                      property.type ===
                                                        "reporting-year" &&
                                                      property.mentionText ===
                                                        year
                                                    ) {
                                                      return entity;
                                                    }
                                                  },
                                                );
                                              },
                                            );

                                          if (yearEntity) {
                                            yearEntityIds.push(yearEntity.id);
                                          }
                                        });
                                      } catch (error) {
                                        console.error(
                                          "Error in processing unique reporting years:",
                                          error,
                                        );
                                        return;
                                      }

                                      setSplitFilesData((oldData) => {
                                        try {
                                          const updatedNewData = oldData.map(
                                            (data) => {
                                              console.log("olddata", data);
                                              console.log("newdata", newData);

                                              if (
                                                data.splitFiles[0].id ===
                                                newData.id
                                              ) {
                                                try {
                                                  const newEntities =
                                                    data.splitFiles[0].labellerOutput.entities.map(
                                                      (entity) => {
                                                        if (
                                                          yearEntityIds.includes(
                                                            entity.id,
                                                          )
                                                        ) {
                                                          try {
                                                            entity.properties.push(
                                                              {
                                                                id: (++currentId).toString(),
                                                                type: entry.label,
                                                                mentionText:
                                                                  "0",
                                                                confidence: 1,
                                                              },
                                                            );
                                                          } catch (error) {
                                                            console.error(
                                                              `Error updating entity properties for entity ID ${entity.id}:`,
                                                              error,
                                                            );
                                                          }
                                                        }
                                                        return entity;
                                                      },
                                                    );

                                                  return {
                                                    ...data,
                                                    splitFiles: [
                                                      {
                                                        ...data.splitFiles[0],
                                                        labellerOutput: {
                                                          ...data.labellerOutput,
                                                          entities: newEntities,
                                                        },
                                                      },
                                                    ],
                                                  };
                                                } catch (error) {
                                                  console.error(
                                                    `Error processing entities for splitFiles ID ${data.splitFiles[0].id}:`,
                                                    error,
                                                  );
                                                }
                                              }
                                              return data;
                                            },
                                          );

                                          return updatedNewData;
                                        } catch (error) {
                                          console.error(
                                            "Error updating splitFilesData:",
                                            error,
                                          );
                                          return oldData;
                                        }
                                      });
                                    } catch (error) {
                                      console.error(
                                        "Error in onClick handler:",
                                        error,
                                      );
                                    }
                                  }}
                                >
                                  +
                                </ActionButton>
                                {entry.rowData.length >= 2 && (
                                  <ActionButton
                                    onClick={() => {
                                      setSplitFilesData((oldData) => {
                                        const ids = entry.rowData[rowIndex].map(
                                          ({ propertyId, entityId }) => ({
                                            propertyId,
                                            entityId,
                                          }),
                                        );

                                        console.log("ids to delete:", ids);
                                        console.log(
                                          "old split files data ",
                                          oldData,
                                        );

                                        const updatedData = oldData.map(
                                          (data) => {
                                            if (
                                              data.splitFiles[0].id ===
                                              newData.id
                                            ) {
                                              console.log(
                                                "Match found for newData.id:",
                                                newData.id,
                                              );

                                              // Update the matching entities
                                              const updatedEntities =
                                                data.splitFiles[0].labellerOutput.entities.map(
                                                  (entity) => {
                                                    if (
                                                      ids.some(
                                                        ({ entityId }) =>
                                                          entity.id ===
                                                          entityId,
                                                      )
                                                    ) {
                                                      console.log(
                                                        "Matching entity found:",
                                                        entity.id,
                                                      );

                                                      const filteredProperties =
                                                        entity.properties.filter(
                                                          (property) => {
                                                            const shouldKeep =
                                                              !ids.some(
                                                                ({
                                                                  propertyId,
                                                                  entityId,
                                                                }) =>
                                                                  property.id ===
                                                                    propertyId &&
                                                                  entity.id ===
                                                                    entityId,
                                                              );

                                                            if (!shouldKeep) {
                                                              console.log(
                                                                `Property removed: propertyId=${property.id}, entityId=${entity.id}`,
                                                              );
                                                            }

                                                            return shouldKeep;
                                                          },
                                                        );

                                                      return {
                                                        ...entity,
                                                        properties:
                                                          filteredProperties,
                                                      };
                                                    }
                                                    return entity;
                                                  },
                                                );

                                              return {
                                                ...data,
                                                splitFiles: [
                                                  {
                                                    ...data.splitFiles[0],
                                                    labellerOutput: {
                                                      ...data.splitFiles[0]
                                                        .labellerOutput,
                                                      entities: updatedEntities,
                                                    },
                                                  },
                                                ],
                                              };
                                            }

                                            // No match; return the data as is
                                            return data;
                                          },
                                        );

                                        console.log(
                                          "Updated splitFilesData:",
                                          updatedData,
                                        );
                                        return updatedData;
                                      });
                                    }}
                                  >
                                    -
                                  </ActionButton>
                                )}
                              </StyledTableCell>
                            </StyledTableRow>
                          );
                        });
                      })}
                  </tbody>
                </StyledTable>
              </div>
            ) : (
              <div style={{ height: "40%", overflowY: "auto" }}>
                <StyledTable
                  style={{
                    borderCollapse: "separate",
                    borderSpacing: 0,
                    padding: "0",
                  }}
                >
                  <StyledTableRow
                    header={true}
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      backgroundColor: "white",
                    }}
                  >
                    {getWipColumnHeaders().map((header, index) => (
                      <StyledTableCell
                        style={{ textAlign: "center" }}
                        key={index}
                        header={true}
                      >
                        {header}
                      </StyledTableCell>
                    ))}
                    <StyledTableCell header={true}>Actions</StyledTableCell>
                  </StyledTableRow>
                  {entries.map((entry, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell>
                        <ValueInput
                          value={entry.contract_number}
                          onFocus={(event) => {
                            const currentValue = event.target.value;
                            if (currentValue === "0") {
                              event.target.select();
                            }
                          }}
                          onChange={(event) => {
                            const updatedSplitFiles = splitFilesData.map(
                              (file) =>
                                file.splitFiles[0].id === newData.id
                                  ? { ...file, isEdited: true }
                                  : file,
                            );
                            setSplitFilesData(updatedSplitFiles);

                            const updatedValue = event.target.value;
                            handleWipLabelUpdate(
                              entry.entityId,
                              "contract_number",
                              updatedValue,
                            );
                          }}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <ValueInput
                          value={entry.project_name}
                          onFocus={(event) => {
                            const currentValue = event.target.value;
                            if (currentValue === "0") {
                              event.target.select();
                            }
                          }}
                          onChange={(event) => {
                            const updatedSplitFiles = splitFilesData.map(
                              (file) =>
                                file.splitFiles[0].id === newData.id
                                  ? { ...file, isEdited: true }
                                  : file,
                            );
                            setSplitFilesData(updatedSplitFiles);

                            const updatedValue = event.target.value;
                            handleWipLabelUpdate(
                              entry.entityId,
                              "project_name",
                              updatedValue,
                            );
                          }}
                        />
                      </StyledTableCell>
                      {newData.labellerModel === "workInProgress" ? (
                        <StyledTableCell>
                          <ValueInput
                            value={entry.estimated_revenue}
                            onFocus={(event) => {
                              const currentValue = event.target.value;
                              if (currentValue === "0") {
                                event.target.select();
                              }
                            }}
                            onChange={(event) => {
                              const updatedSplitFiles = splitFilesData.map(
                                (file) =>
                                  file.splitFiles[0].id === newData.id
                                    ? { ...file, isEdited: true }
                                    : file,
                              );
                              setSplitFilesData(updatedSplitFiles);

                              const updatedValue = event.target.value;
                              handleWipLabelUpdate(
                                entry.entityId,
                                "estimated_revenue",
                                updatedValue,
                              );
                            }}
                          />
                        </StyledTableCell>
                      ) : (
                        <StyledTableCell>
                          <ValueInput
                            value={entry.estimated_revenue}
                            onFocus={(event) => {
                              const currentValue = event.target.value;
                              if (currentValue === "0") {
                                event.target.select();
                              }
                            }}
                            onChange={(event) => {
                              const updatedSplitFiles = splitFilesData.map(
                                (file) =>
                                  file.splitFiles[0].id === newData.id
                                    ? { ...file, isEdited: true }
                                    : file,
                              );
                              setSplitFilesData(updatedSplitFiles);

                              const updatedValue = event.target.value;
                              handleWipLabelUpdate(
                                entry.entityId,
                                "project_value_or_estimated_revenue",
                                updatedValue,
                              );
                            }}
                          />
                        </StyledTableCell>
                      )}
                      <StyledTableCell>
                        <ValueInput
                          value={entry.estimated_cost_of_revenue}
                          onFocus={(event) => {
                            const currentValue = event.target.value;
                            if (currentValue === "0") {
                              event.target.select();
                            }
                          }}
                          onChange={(event) => {
                            const updatedSplitFiles = splitFilesData.map(
                              (file) =>
                                file.splitFiles[0].id === newData.id
                                  ? { ...file, isEdited: true }
                                  : file,
                            );
                            setSplitFilesData(updatedSplitFiles);

                            const updatedValue = event.target.value;
                            handleWipLabelUpdate(
                              entry.entityId,
                              "estimated_cost_of_revenue",
                              updatedValue,
                            );
                          }}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <ValueInput
                          value={entry.estimated_gross_profit}
                          onFocus={(event) => {
                            const currentValue = event.target.value;
                            if (currentValue === "0") {
                              event.target.select();
                            }
                          }}
                          onChange={(event) => {
                            const updatedSplitFiles = splitFilesData.map(
                              (file) =>
                                file.splitFiles[0].id === newData.id
                                  ? { ...file, isEdited: true }
                                  : file,
                            );
                            setSplitFilesData(updatedSplitFiles);

                            const updatedValue = event.target.value;
                            handleWipLabelUpdate(
                              entry.entityId,
                              "estimated-gross-profit",
                              updatedValue,
                            );
                          }}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <ValueInput
                          value={entry.cost_incurred_to_date}
                          onFocus={(event) => {
                            const currentValue = event.target.value;
                            if (currentValue === "0") {
                              event.target.select();
                            }
                          }}
                          onChange={(event) => {
                            const updatedSplitFiles = splitFilesData.map(
                              (file) =>
                                file.splitFiles[0].id === newData.id
                                  ? { ...file, isEdited: true }
                                  : file,
                            );
                            setSplitFilesData(updatedSplitFiles);

                            const updatedValue = event.target.value;
                            handleWipLabelUpdate(
                              entry.entityId,
                              "cost_incurred_to_date",
                              updatedValue,
                            );
                          }}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <ValueInput
                          value={entry.billings_to_date}
                          onFocus={(event) => {
                            const currentValue = event.target.value;
                            if (currentValue === "0") {
                              event.target.select();
                            }
                          }}
                          onChange={(event) => {
                            const updatedSplitFiles = splitFilesData.map(
                              (file) =>
                                file.splitFiles[0].id === newData.id
                                  ? { ...file, isEdited: true }
                                  : file,
                            );
                            setSplitFilesData(updatedSplitFiles);

                            const updatedValue = event.target.value;
                            handleWipLabelUpdate(
                              entry.entityId,
                              "billings_to_date",
                              updatedValue,
                            );
                          }}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <ValueInput
                          value={entry.current_year_earned_revenue}
                          onFocus={(event) => {
                            const currentValue = event.target.value;
                            if (currentValue === "0") {
                              event.target.select();
                            }
                          }}
                          onChange={(event) => {
                            const updatedSplitFiles = splitFilesData.map(
                              (file) =>
                                file.splitFiles[0].id === newData.id
                                  ? { ...file, isEdited: true }
                                  : file,
                            );
                            setSplitFilesData(updatedSplitFiles);

                            const updatedValue = event.target.value;
                            handleWipLabelUpdate(
                              entry.entityId,
                              "current_year_earned_revenue",
                              updatedValue,
                            );
                          }}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <ValueInput
                          value={entry.current_year_contract_costs}
                          onFocus={(event) => {
                            const currentValue = event.target.value;
                            if (currentValue === "0") {
                              event.target.select();
                            }
                          }}
                          onChange={(event) => {
                            const updatedSplitFiles = splitFilesData.map(
                              (file) =>
                                file.splitFiles[0].id === newData.id
                                  ? { ...file, isEdited: true }
                                  : file,
                            );
                            setSplitFilesData(updatedSplitFiles);

                            const updatedValue = event.target.value;
                            handleWipLabelUpdate(
                              entry.entityId,
                              "current_year_contract_costs",
                              updatedValue,
                            );
                          }}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <ActionButton
                          onClick={() => {
                            const propertyTypes = [
                              "billings_to_date",
                              "estimated_revenue",
                              "estimated_cost_of_revenue",
                              "estimated_gross_profit",
                              "cost_incurred_to_date",
                              "current_year_earned_revenue",
                              "current_year_contract_costs",
                            ];

                            let currentId = getNewestId(
                              splitFilesData.find(
                                (data) => data.splitFiles[0].id === newData.id,
                              ).splitFiles[0],
                            );
                            setSplitFilesData((oldData) => {
                              const updatedData = oldData.map((data) => {
                                if (data.splitFiles[0].id === newData.id) {
                                  data.splitFiles[0].labellerOutput.entities.push(
                                    {
                                      id: (++currentId).toString(),
                                      type: "project",
                                      properties: propertyTypes.map((type) => ({
                                        type,
                                        id: (++currentId).toString(),
                                        mentionText: 0,
                                      })),
                                    },
                                  );
                                }
                                return data;
                              });
                              return updatedData;
                            });
                          }}
                        >
                          +
                        </ActionButton>
                        {(() => {
                          const matchedSplit = splitFilesData.find(
                            (data) => data.splitFiles[0].id === newData.id,
                          );

                          const shouldDisableDeleting =
                            matchedSplit.splitFiles[0].labellerOutput.entities.filter(
                              (entity) => entity.type === "project",
                            ).length === 1;

                          return (
                            !shouldDisableDeleting && (
                              <ActionButton
                                onClick={() => {
                                  setSplitFilesData((oldData) => {
                                    console.log("Old data:", oldData);
                                    console.log("Entity id: ", entry.entityId);

                                    const updatedData = oldData.map((data) => {
                                      // Ensure splitFiles exists
                                      if (
                                        data.splitFiles?.[0]?.id === newData.id
                                      ) {
                                        console.log(
                                          "Condition met for:",
                                          data.splitFiles[0].id,
                                        );

                                        const updatedEntities =
                                          data.splitFiles[0].labellerOutput.entities.filter(
                                            (entity) =>
                                              entity.id !== entry.entityId,
                                          );

                                        return {
                                          ...data,
                                          splitFiles: [
                                            {
                                              ...data.splitFiles[0],
                                              labellerOutput: {
                                                ...data.splitFiles[0]
                                                  .labellerOutput,
                                                entities: updatedEntities,
                                              },
                                            },
                                          ],
                                        };
                                      }
                                      return data;
                                    });

                                    console.log("Updated data:", updatedData);
                                    return updatedData;
                                  });

                                  console.log("entries ", entries);
                                }}
                              >
                                -
                              </ActionButton>
                            )
                          );
                        })()}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                  <StyledTableRow>
                    <StyledTableCell>
                      <strong>Totals:</strong>
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ textAlign: "right", padding: "16px" }}
                    >
                      -
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ textAlign: "right", padding: "16px" }}
                    >
                      {(() => {
                        return entries
                          .reduce((acc, { estimated_revenue }) => {
                            const clean = parseInt(
                              estimated_revenue.replace(/[\s,()]/g, "") || "0",
                            );
                            return acc + clean;
                          }, 0)
                          .toLocaleString();
                      })()}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ textAlign: "right", padding: "16px" }}
                    >
                      {(() => {
                        return entries
                          .reduce((acc, { estimated_cost_of_revenue }) => {
                            const clean = parseInt(
                              estimated_cost_of_revenue.replace(
                                /[\s,()]/g,
                                "",
                              ) || "0",
                            );
                            return acc + clean;
                          }, 0)
                          .toLocaleString();
                      })()}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ textAlign: "right", padding: "16px" }}
                    >
                      {(() => {
                        return entries
                          .reduce((acc, { estimated_gross_profit }) => {
                            const clean = parseInt(
                              estimated_gross_profit.replace(/[\s,()]/g, "") ||
                                "0",
                            );
                            return acc + clean;
                          }, 0)
                          .toLocaleString();
                      })()}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ textAlign: "right", padding: "16px" }}
                    >
                      {(() => {
                        return entries
                          .reduce((acc, { cost_incurred_to_date }) => {
                            const clean = parseInt(
                              cost_incurred_to_date.replace(/[\s,()]/g, "") ||
                                "0",
                            );
                            return acc + clean;
                          }, 0)
                          .toLocaleString();
                      })()}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ textAlign: "right", padding: "16px" }}
                    >
                      {(() => {
                        return entries
                          .reduce((acc, { billings_to_date }) => {
                            const clean = parseInt(
                              billings_to_date.replace(/[\s,()]/g, "") || "0",
                            );
                            return acc + clean;
                          }, 0)
                          .toLocaleString();
                      })()}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ textAlign: "right", padding: "16px" }}
                    >
                      {(() => {
                        return entries
                          .reduce((acc, { current_year_earned_revenue }) => {
                            const clean = parseInt(
                              current_year_earned_revenue.replace(
                                /[\s,()]/g,
                                "",
                              ) || "0",
                            );
                            return acc + clean;
                          }, 0)
                          .toLocaleString();
                      })()}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ textAlign: "right", padding: "16px" }}
                    >
                      {(() => {
                        return entries
                          .reduce((acc, { current_year_contract_costs }) => {
                            const clean = parseInt(
                              current_year_contract_costs.replace(
                                /[\s,()]/g,
                                "",
                              ) || "0",
                            );
                            return acc + clean;
                          }, 0)
                          .toLocaleString();
                      })()}
                    </StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                  </StyledTableRow>
                </StyledTable>
              </div>
            )}
          </div>
          {isFinancialDocument(newData.labellerModel) && (
            <div style={{ width: "50%" }}>
              <iframe
                src={pdfSrc}
                title="PDF Viewer"
                width="100%"
                height="100%"
              />
              {/*<DocumentViewer*/}
              {/*  src={pdfSrc}*/}
              {/*  width={"715px"}*/}
              {/*  height={"1300px"}*/}
              {/*  coordinates={hoveredLabel}*/}
              {/*/>*/}
            </div>
          )}
        </HorizontalContainer>
      </ScreenRoot>
    </>
  );
}

const EditIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1744_575)">
      <path
        d="M15.4864 0.500019C16.1662 0.502058 16.8176 0.772743 17.2983 1.25297L18.6853 2.63071C18.9426 2.87469 19.1476 3.16847 19.2877 3.49416C19.4278 3.81984 19.5 4.17062 19.5 4.5251C19.5 4.87958 19.4278 5.23035 19.2877 5.55604C19.1476 5.88173 18.9426 6.17551 18.6853 6.41949L11.4699 13.6286C10.3235 14.7981 9.17701 15.9355 8.02255 17.0729C7.90697 17.1876 7.76731 17.2752 7.61368 17.3293C5.52924 18.0341 3.43679 18.723 1.35235 19.4199C1.23457 19.4664 1.11002 19.4934 0.983563 19.5C0.902828 19.4953 0.824337 19.4717 0.754491 19.431C0.684644 19.3903 0.625421 19.3336 0.581651 19.2657C0.537882 19.1977 0.510805 19.1204 0.502629 19.04C0.494453 18.9596 0.50541 18.8785 0.534607 18.8031L1.85742 14.7981C2.13 13.9971 2.39457 13.196 2.65913 12.395C2.70283 12.2623 2.77695 12.1416 2.87559 12.0426L13.5784 1.30904C13.825 1.05206 14.1213 0.84784 14.4493 0.708768C14.7773 0.569695 15.1301 0.498675 15.4864 0.500019ZM13.0813 3.3356L3.98996 12.395L7.5736 15.9996L16.665 6.93214L13.0813 3.3356ZM17.4747 6.17118C17.6591 5.98694 17.8595 5.81072 18.0359 5.61848C18.3076 5.33019 18.4589 4.94913 18.4589 4.55313C18.4589 4.15714 18.3076 3.77608 18.0359 3.48779C17.5388 2.95111 17.0177 2.44648 16.4966 1.94985C16.3272 1.7908 16.1232 1.67327 15.9006 1.60655C15.678 1.53982 15.4429 1.52572 15.2139 1.56536C14.6551 1.72676 14.1667 2.07088 13.8269 2.5426L17.4747 6.17118ZM1.84941 18.1863L6.5875 16.5843L3.41274 13.4283L1.84941 18.1863Z"
        fill="#B9B9C3"
      />
      <path
        d="M17.2983 1.25297L17.2276 1.32372L17.2278 1.32391L17.2983 1.25297ZM18.6853 2.63071L18.6148 2.70167L18.6165 2.70328L18.6853 2.63071ZM18.6853 6.41949L18.6164 6.34689L18.6146 6.34875L18.6853 6.41949ZM11.4699 13.6286L11.3992 13.5578L11.3985 13.5586L11.4699 13.6286ZM8.02255 17.0729L7.95237 17.0017L7.95212 17.0019L8.02255 17.0729ZM7.61368 17.3293L7.64572 17.424L7.64689 17.4236L7.61368 17.3293ZM1.35235 19.4199L1.3206 19.3249L1.31566 19.3269L1.35235 19.4199ZM0.983563 19.5L0.977777 19.6004L0.98877 19.5999L0.983563 19.5ZM0.534607 18.8031L0.627971 18.8393L0.629561 18.8345L0.534607 18.8031ZM1.85742 14.7981L1.76275 14.7658L1.76247 14.7667L1.85742 14.7981ZM2.65913 12.395L2.75409 12.4264L2.75411 12.4263L2.65913 12.395ZM2.87559 12.0426L2.80478 11.972L2.80474 11.972L2.87559 12.0426ZM13.5784 1.30904L13.6492 1.37966L13.6505 1.37828L13.5784 1.30904ZM13.0813 3.3356L13.1522 3.26501L13.0816 3.19417L13.0107 3.26476L13.0813 3.3356ZM3.98996 12.395L3.91938 12.3242L3.84862 12.3947L3.91905 12.4655L3.98996 12.395ZM7.5736 15.9996L7.50268 16.0701L7.5733 16.1411L7.64421 16.0704L7.5736 15.9996ZM16.665 6.93214L16.7356 7.00294L16.8063 6.93236L16.7358 6.86155L16.665 6.93214ZM17.4747 6.17118L17.4042 6.24207L17.4748 6.31238L17.5454 6.24192L17.4747 6.17118ZM18.0359 5.61848L17.9631 5.54988L17.9622 5.55087L18.0359 5.61848ZM18.4589 4.55313H18.5589H18.4589ZM18.0359 3.48779L17.9625 3.55574L17.9631 3.55638L18.0359 3.48779ZM16.4966 1.94985L16.5656 1.87746L16.5651 1.87696L16.4966 1.94985ZM15.2139 1.56536L15.1967 1.46623L15.1861 1.46929L15.2139 1.56536ZM13.8269 2.5426L13.7458 2.48415L13.6959 2.55335L13.7564 2.61349L13.8269 2.5426ZM1.84941 18.1863L1.7544 18.1551L1.69197 18.3451L1.88144 18.2811L1.84941 18.1863ZM6.5875 16.5843L6.61953 16.6791L6.77258 16.6273L6.658 16.5134L6.5875 16.5843ZM3.41274 13.4283L3.48324 13.3574L3.36831 13.2432L3.31773 13.3971L3.41274 13.4283ZM15.4861 0.600018C16.1395 0.601979 16.7656 0.862157 17.2276 1.32372L17.369 1.18222C16.8696 0.683329 16.1929 0.402138 15.4867 0.400019L15.4861 0.600018ZM17.2278 1.32391L18.6148 2.70165L18.7557 2.55976L17.3688 1.18202L17.2278 1.32391ZM18.6165 2.70328C18.864 2.93792 19.0611 3.22046 19.1958 3.53367L19.3796 3.45465C19.2341 3.11648 19.0213 2.81145 18.7541 2.55813L18.6165 2.70328ZM19.1958 3.53367C19.3305 3.84687 19.4 4.1842 19.4 4.5251H19.6C19.6 4.15703 19.525 3.79281 19.3796 3.45465L19.1958 3.53367ZM19.4 4.5251C19.4 4.86599 19.3305 5.20332 19.1958 5.51653L19.3796 5.59555C19.525 5.25738 19.6 4.89317 19.6 4.5251H19.4ZM19.1958 5.51653C19.0611 5.82974 18.864 6.11227 18.6165 6.34691L18.7541 6.49207C19.0213 6.23875 19.2341 5.93372 19.3796 5.59555L19.1958 5.51653ZM18.6146 6.34875L11.3992 13.5578L11.5406 13.6993L18.7559 6.49023L18.6146 6.34875ZM11.3985 13.5586C10.2527 14.7274 9.10669 15.8644 7.95237 17.0017L8.09274 17.1442C9.24733 16.0066 10.3943 14.8687 11.5413 13.6986L11.3985 13.5586ZM7.95212 17.0019C7.84707 17.1062 7.72012 17.1858 7.58047 17.2349L7.64689 17.4236C7.8145 17.3646 7.96688 17.269 8.09298 17.1439L7.95212 17.0019ZM7.58165 17.2345C5.49735 17.9394 3.40574 18.628 1.32064 19.3251L1.38406 19.5147C3.46784 18.8181 5.56113 18.1289 7.64572 17.424L7.58165 17.2345ZM1.31566 19.3269C1.20793 19.3694 1.09402 19.3941 0.978355 19.4001L0.98877 19.5999C1.12602 19.5927 1.2612 19.5633 1.38904 19.5129L1.31566 19.3269ZM0.989313 19.4002C0.924299 19.3964 0.861096 19.3774 0.804859 19.3446L0.704123 19.5174C0.787578 19.566 0.881357 19.5943 0.977812 19.5998L0.989313 19.4002ZM0.804859 19.3446C0.748622 19.3118 0.700948 19.2662 0.665716 19.2115L0.497586 19.3198C0.549895 19.401 0.620666 19.4687 0.704123 19.5174L0.804859 19.3446ZM0.665716 19.2115C0.630486 19.1568 0.608695 19.0946 0.602116 19.0299L0.403142 19.0501C0.412914 19.1462 0.445277 19.2386 0.497586 19.3198L0.665716 19.2115ZM0.602116 19.0299C0.595536 18.9652 0.604354 18.8999 0.627851 18.8393L0.441362 18.767C0.406467 18.857 0.39337 18.9541 0.403142 19.0501L0.602116 19.0299ZM0.629561 18.8345L1.95238 14.8294L1.76247 14.7667L0.439652 18.7718L0.629561 18.8345ZM1.95209 14.8303C2.22484 14.0288 2.48955 13.2273 2.75409 12.4264L2.56418 12.3637C2.29959 13.1648 2.03517 13.9653 1.76275 14.7658L1.95209 14.8303ZM2.75411 12.4263C2.79294 12.3084 2.8588 12.2012 2.94645 12.1132L2.80474 11.972C2.69511 12.0821 2.61272 12.2162 2.56415 12.3638L2.75411 12.4263ZM2.9464 12.1132L13.6492 1.37965L13.5076 1.23843L2.80478 11.972L2.9464 12.1132ZM13.6505 1.37828C13.8877 1.13108 14.1728 0.93462 14.4883 0.800834L14.4102 0.616701C14.0698 0.76106 13.7622 0.973049 13.5062 1.2398L13.6505 1.37828ZM14.4883 0.800834C14.8038 0.667047 15.1433 0.598725 15.4861 0.600018L15.4868 0.400019C15.117 0.398624 14.7507 0.472343 14.4102 0.616701L14.4883 0.800834ZM13.0107 3.26476L3.91938 12.3242L4.06055 12.4659L13.1519 3.40643L13.0107 3.26476ZM3.91905 12.4655L7.50268 16.0701L7.64451 15.9291L4.06088 12.3245L3.91905 12.4655ZM7.64421 16.0704L16.7356 7.00294L16.5943 6.86133L7.50298 15.9288L7.64421 16.0704ZM16.7358 6.86155L13.1522 3.26501L13.0105 3.40618L16.5941 7.00272L16.7358 6.86155ZM17.5454 6.24192C17.7226 6.06479 17.9322 5.87942 18.1096 5.68608L17.9622 5.55087C17.7868 5.74203 17.5955 5.9091 17.404 6.10043L17.5454 6.24192ZM18.1086 5.68707C18.3978 5.38023 18.5589 4.97464 18.5589 4.55313H18.3589C18.3589 4.92362 18.2173 5.28015 17.9631 5.54989L18.1086 5.68707ZM18.5589 4.55313C18.5589 4.13163 18.3978 3.72604 18.1086 3.4192L17.9631 3.55638C18.2173 3.82612 18.3589 4.18265 18.3589 4.55313H18.5589ZM18.1092 3.41984C17.6099 2.88072 17.0869 2.37427 16.5656 1.87746L16.4276 2.02224C16.9485 2.51868 17.4677 3.0215 17.9625 3.55574L18.1092 3.41984ZM16.5651 1.87696C16.3844 1.7073 16.1668 1.58193 15.9293 1.51076L15.8719 1.70234C16.0797 1.76462 16.2701 1.87431 16.4281 2.02274L16.5651 1.87696ZM15.9293 1.51076C15.6918 1.43958 15.4411 1.42454 15.1968 1.46683L15.2309 1.6639C15.4447 1.6269 15.6641 1.64006 15.8719 1.70234L15.9293 1.51076ZM15.1861 1.46929C14.6058 1.6369 14.0986 1.99426 13.7458 2.48415L13.9081 2.60104C14.2347 2.1475 14.7043 1.81663 15.2416 1.66144L15.1861 1.46929ZM13.7564 2.61349L17.4042 6.24207L17.5452 6.10028L13.8974 2.4717L13.7564 2.61349ZM1.88144 18.2811L6.61953 16.6791L6.55547 16.4896L1.81738 18.0916L1.88144 18.2811ZM6.658 16.5134L3.48324 13.3574L3.34223 13.4993L6.517 16.6552L6.658 16.5134ZM3.31773 13.3971L1.7544 18.1551L1.94441 18.2176L3.50774 13.4596L3.31773 13.3971Z"
        fill="#B9B9C3"
      />
    </g>
    <defs>
      <clipPath id="clip0_1744_575">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
